{
  "navigation.customers": "Kunden",
  "navigation.contacts": "Kontakte",
  "navigation.projects": "Projekte",
  "navigation.subscriptions": "Abonnements",
  "navigation.settlements": "Abrechnungen",
  "navigation.invoices": "Rechnungen",
  "navigation.configuration": "Konfiguration",
  "navigation.marketing": "Marketing",
  "navigation.analysis": "Analyse",
  "breadcrumb.analysis": "Analyse",
  "view.analysis.headline": "Analyse",
  "tab.analysis.income": "Einnahmen",
  "tab.analysis.expenses": "Ausgaben",
  "view.analysisExpenseOverview.col.category": "Kostenart",
  "view.analysisExpenseOverview.col.total": "Summe",
  "view.analysisExpenseOverview.total": "Gesamt",
  "view.analysisExpenseOverview.unassigned": "Nicht zugeordnet",
  "view.analysisExpenseOverview.empty": "In diesem Zeitraum gibt es keine Ausgaben.",
  "view.analysisExpenseOverview.legend.provisional": "Vorläufig: Der Monat ist noch nicht vollständig erfasst, oder der Betrag beruht auf einem vorgeschlagenen Leistungszeitraum.",
  "view.analysisExpenseOverview.legend.provisionalShort": "Vorläufig",
  "view.analysisExpenseOverview.legend.drillDown": "Klick auf einen Betrag zeigt die zugehörigen Rechnungen.",
  "view.analysisExpenseOverview.notIncluded": "Gehälter, Sozialabgaben und Steuern sind nicht enthalten. Alle Beträge sind netto, nach Leistungsmonat.",
  "component.periodTable.expand": "Aufklappen",
  "component.periodTable.collapse": "Zuklappen",
  "component.analysis.range": "{from} – {to}",
  "component.analysis.previousMonth": "Einen Monat zurück",
  "component.analysis.nextMonth": "Einen Monat vor",
  "component.analysis.kpi.change": "Veränderung zum Vormonat",
  "component.analysis.kpi.change.sub": "{percent} zum Vormonat",
  "component.analysis.kpi.average": "Ø der Monate",
  "component.analysis.kpi.average.sub": "{count, plural, one {# abgeschlossener Monat} other {# abgeschlossene Monate}}",
  "component.analysis.ranking.new": "neu",
  "component.analysis.ranking.showAll": "Alle {count} anzeigen",
  "component.analysis.ranking.showLess": "Weniger anzeigen",
  "component.periodTable.changeToPrevious": "Veränderung zur Vorperiode",
  "view.analysisExpenseOverview.kpi.total": "Ausgaben",
  "view.analysisExpenseOverview.kpi.toConfirm": "Zu bestätigen",
  "view.analysisExpenseOverview.kpi.toConfirm.sub": "Rechnungen mit vorgeschlagenem Leistungszeitraum",
  "view.analysisExpenseOverview.ranking": "Ausgaben nach Lieferant",
  "view.analysisExpenseOverview.ranking.empty": "In diesem Zeitraum gibt es keine Ausgaben.",
  "view.analysisExpenseOverview.ranking.gone": "keine Rechnung",
  "view.analysisIncome.kpi.total": "Einnahmen",
  "view.analysisIncome.kpi.perCustomer": "Ø pro Kunde",
  "view.analysisIncome.kpi.perCustomer.sub": "{customers, plural, one {# Kunde} other {# Kunden}}, {subscriptions, plural, one {# abgerechnete Subscription} other {# abgerechnete Subscriptions}}",
  "view.analysisIncome.col.group": "Gruppe",
  "view.analysisIncome.col.total": "Summe",
  "view.analysisIncome.total": "Gesamt",
  "view.analysisIncome.ranking": "Einnahmen nach Kunde",
  "view.analysisIncome.ranking.gone": "weggefallen",
  "view.analysisIncome.ranking.topThree": "Die drei größten Kunden machen {percent} der Einnahmen aus.",
  "view.analysisIncome.ranking.newAndGone": "{newCount, plural, =0 {Keine neuen Kunden} one {# neuer Kunde} other {# neue Kunden}}, {goneCount, plural, =0 {keine weggefallenen Kunden} one {# weggefallener Kunde} other {# weggefallene Kunden}}",
  "view.analysisIncome.legend.provisional": "Vorläufig: Der Monat ist noch nicht zu Ende, es fehlen noch Abrechnungen.",
  "view.analysisIncome.legend.expand": "Mit dem Pfeil vor einer Gruppe klappst du ihre Kostenkategorien auf.",
  "view.analysisIncome.notice": "Alle Beträge sind netto. Die Einnahmen zählen im Monat des Stichtags der Abrechnung, das ist immer das Monatsende. Bei Subscriptions ist das in aller Regel der Leistungsmonat. Nur vereinzelte Nachberechnungen für frühere Monate zählen im Monat der Abrechnung.",
  "revenue.group.CLUSTERS": "Cluster",
  "revenue.group.INSTANCES_AND_PROJECTS": "Instanzen & Projekte",
  "revenue.group.DATABASES": "Datenbanken",
  "revenue.group.STORAGE_AND_TRAFFIC": "Speicher & Traffic",
  "revenue.group.SERVICES": "Dienstleistungen",
  "revenue.group.OTHER": "Sonstiges",
  "revenue.costCategory.uncategorized": "Ohne Kategorie",
  "view.suppliers.summary": "{total, plural, one {# Lieferant} other {# Lieferanten}}, davon {unassigned} ohne Kostenart",
  "view.suppliers.search": "Lieferant oder Schreibvariante suchen",
  "view.suppliers.empty": "Noch keine Lieferanten. Sie entstehen beim Import der Eingangsrechnungen aus FastBill.",
  "view.suppliers.col.name": "Lieferant",
  "view.suppliers.col.expenseCategory": "Kostenart",
  "view.suppliers.col.billingCycle": "Abrechnungsrhythmus",
  "view.suppliers.col.netAmount": "Netto {start} – {end}",
  "view.suppliers.col.invoiceCount": "Rechnungen",
  "view.suppliers.col.servicePeriods": "Leistungszeiträume",
  "view.suppliers.proposals": "{count, plural, one {# Vorschlag} other {# Vorschläge}}",
  "view.suppliers.proposals.title": "Vorgeschlagene Leistungszeiträume ansehen und bestätigen",
  "view.suppliers.unassigned": "Nicht zugeordnet",
  "view.suppliers.noBillingCycle": "– kein Rhythmus",
  "view.suppliers.action.configure": "Lieferant konfigurieren",
  "view.suppliers.action.merge": "Mit anderem Lieferanten zusammenführen",
  "view.suppliers.action.separate": "Als eigenen Lieferanten abtrennen",
  "expense.category.INFRASTRUCTURE": "Infrastruktur",
  "expense.category.SERVICES_AND_LICENSES": "Dienste & Lizenzen",
  "expense.category.HARDWARE_AND_EQUIPMENT": "Hardware & Ausstattung",
  "expense.category.VEHICLES": "Fahrzeuge",
  "expense.category.TRAVEL": "Reisen",
  "expense.category.INSURANCE": "Versicherungen",
  "expense.category.CONSULTING_AND_ADMINISTRATION": "Beratung & Verwaltung",
  "expense.category.MEMBERSHIPS_AND_DONATIONS": "Mitgliedschaften & Spenden",
  "expense.category.OTHER": "Sonstiges",
  "expense.billingCycle.MONTHLY_IN_ARREARS": "monatlich nachträglich",
  "expense.billingCycle.MONTHLY_IN_ADVANCE": "monatlich im Voraus",
  "expense.billingCycle.QUARTERLY_IN_ADVANCE": "vierteljährlich im Voraus",
  "expense.billingCycle.YEARLY_IN_ADVANCE": "jährlich im Voraus",
  "expense.billingCycle.ONE_TIME": "einmalig",
  "expense.amountEstimateSource.HETZNER": "Hetzner-Kostenschätzung",
  "view.incomingInvoices.filter.supplier": "Lieferant",
  "view.incomingInvoices.filter.allSuppliers": "Alle Lieferanten",
  "view.incomingInvoices.filter.category": "Kostenart",
  "view.incomingInvoices.filter.allCategories": "Alle Kostenarten",
  "view.incomingInvoices.filter.month": "Leistungsmonat",
  "view.incomingInvoices.filter.status": "Status des Leistungszeitraums",
  "view.incomingInvoices.filter.allStatuses": "Alle Leistungszeiträume",
  "view.incomingInvoices.filter.search": "Rechnungsnr., Lieferant oder Betrag",
  "view.incomingInvoices.filter.deleted": "Gelöschte anzeigen",
  "view.incomingInvoices.filter.reset": "Filter zurücksetzen",
  "view.incomingInvoices.summary": "{count, plural, one {# Rechnung} other {# Rechnungen}}",
  "view.incomingInvoices.empty": "Keine Rechnungen für diesen Filter.",
  "view.incomingInvoices.col.supplier": "Lieferant",
  "view.incomingInvoices.col.invoiceNumber": "Rechnungsnummer",
  "view.incomingInvoices.col.invoiceDate": "Rechnungsdatum",
  "view.incomingInvoices.col.servicePeriod": "Leistungszeitraum",
  "view.incomingInvoices.action.confirmAll": "Alle {count} bestätigen",
  "view.incomingInvoices.col.expenseCategory": "Kostenart",
  "view.incomingInvoices.filter.monthPlaceholder": "JJJJ-MM",
  "view.incomingInvoices.filter.monthHint": "Zeigt Rechnungen, deren Leistungszeitraum diesen Monat berührt",
  "view.incomingInvoices.serviceMonthHint": "Gezeigt werden alle Rechnungen, deren Leistungszeitraum den Monat berührt. Bei längeren Zeiträumen zählt nur der Anteil des Monats.",
  "view.incomingInvoices.serviceMonthTotal": "Summe der Anteile im Monat: {amount}",
  "view.incomingInvoices.col.shareInMonth": "Anteil im Monat (EUR)",
  "view.incomingInvoices.col.netAmount": "Netto (EUR)",
  "view.incomingInvoices.col.paidDate": "Bezahlt am",
  "view.incomingInvoices.hasDocument": "PDF archiviert",
  "view.incomingInvoices.action.show": "Rechnung anzeigen",
  "expense.servicePeriodStatus.PROPOSED": "vorgeschlagen",
  "expense.servicePeriodStatus.CONFIRMED": "bestätigt",
  "expense.servicePeriodSource.FASTBILL": "Aus FastBill übernommen",
  "expense.servicePeriodSource.BILLING_CYCLE": "Aus dem Abrechnungsrhythmus des Lieferanten vorgeschlagen",
  "expense.servicePeriodSource.MANUAL": "Von Hand gesetzt",
  "expense.servicePeriod.invoiceMonth": "Rechnungsmonat",
  "expense.category.overridden": "überschrieben",
  "expense.category.overridden.title": "Für diese Rechnung abweichend von der Kostenart des Lieferanten",
  "view.incomingInvoice.back": "Rechnungen",
  "view.incomingInvoice.details": "Rechnungsdaten",
  "view.incomingInvoice.supplier": "Lieferant",
  "view.incomingInvoice.dueDate": "Fällig am",
  "view.incomingInvoice.netAmountInEuro": "Netto (EUR)",
  "view.incomingInvoice.netAmount": "Netto",
  "view.incomingInvoice.vatAmount": "Umsatzsteuer",
  "view.incomingInvoice.grossAmount": "Brutto",
  "view.incomingInvoice.exchangeRate": "Wechselkurs",
  "view.incomingInvoice.exchangeRateValue": "1 EUR = {rate} {currency}",
  "view.incomingInvoice.fastBillInvoiceId": "FastBill-ID",
  "view.incomingInvoice.deletedInFastBill": "In FastBill gelöscht am {date}",
  "view.incomingInvoice.document.notArchived": "Für diese Rechnung ist noch kein PDF archiviert.",
  "view.incomingInvoice.document.loading": "Das PDF wird geladen …",
  "view.incomingInvoice.category.ofSupplier": "Kostenart des Lieferanten",
  "view.incomingInvoice.category.ofSupplierWithCategory": "Kostenart des Lieferanten ({category})",
  "view.incomingInvoice.category.ofSupplierHint": "Die Rechnung zählt zur Kostenart ihres Lieferanten. Wählst du eine andere, gilt sie nur für diese Rechnung.",
  "view.incomingInvoice.category.overriddenHint": "Die Kostenart ist für diese Rechnung überschrieben. Mit „Kostenart des Lieferanten“ setzt du sie zurück.",
  "view.incomingInvoice.servicePeriod.confirm": "Bestätigen",
  "view.incomingInvoice.servicePeriod.start": "Von",
  "view.incomingInvoice.servicePeriod.end": "Bis (einschließlich)",
  "view.incomingInvoice.servicePeriod.endBeforeStart": "Das Ende darf nicht vor dem Anfang liegen.",
  "view.incomingInvoice.servicePeriod.correct": "Zeitraum speichern und bestätigen",
  "view.incomingInvoice.servicePeriod.set": "Zeitraum festlegen",
  "view.incomingInvoice.servicePeriod.invoiceMonthHint": "Ohne eigenen Leistungszeitraum zählt die Rechnung im Monat ihres Rechnungsdatums.",
  "errors.failedToChangeExpenseInvoiceCategory": "Die Kostenart der Rechnung konnte nicht gespeichert werden.",
  "errors.failedToConfirmServicePeriod": "Der Leistungszeitraum konnte nicht bestätigt werden.",
  "errors.failedToCorrectServicePeriod": "Der Leistungszeitraum konnte nicht gespeichert werden.",
  "errors.failedToAssignSupplierExpenseCategory": "Die Kostenart konnte nicht gespeichert werden.",
  "errors.failedToAssignSupplierBillingCycle": "Der Abrechnungsrhythmus konnte nicht gespeichert werden.",
  "errors.failedToAssignSupplierAmountEstimateSource": "Die Quelle der Schätzung konnte nicht gespeichert werden.",
  "errors.failedToRenameSupplier": "Der Lieferant konnte nicht umbenannt werden.",
  "errors.failedToConfirmSupplierServicePeriodProposals": "Die vorgeschlagenen Leistungszeiträume konnten nicht bestätigt werden.",
  "dialog.ConfirmSupplierServicePeriodProposalsDialog.headline": "Leistungszeiträume bestätigen",
  "dialog.ConfirmSupplierServicePeriodProposalsDialog.submitLabel": "Bestätigen",
  "dialog.ConfirmSupplierServicePeriodProposalsDialog.confirmMessage": "{count, plural, one {Den vorgeschlagenen Leistungszeitraum} other {Alle # vorgeschlagenen Leistungszeiträume}} von {name} bestätigen? Einzelne Rechnungen kannst du danach weiterhin korrigieren.",
  "errors.failedToMergeSupplier": "Die Lieferanten konnten nicht zusammengeführt werden.",
  "errors.failedToSeparateSupplierSpelling": "Die Schreibvariante konnte nicht abgetrennt werden.",
  "dialog.ConfigureSupplierDialog.headline": "Lieferant konfigurieren: {name}",
  "dialog.ConfigureSupplierDialog.amountEstimateSourceLabel": "Betrag schätzen aus",
  "dialog.ConfigureSupplierDialog.noAmountEstimateSource": "Letzte Rechnungen fortschreiben",
  "dialog.ConfigureSupplierDialog.amountEstimateSourceHint": "Die Vorschau nimmt die erwarteten Beträge dieses Lieferanten aus der gewählten Schätzung, solange sie aktuell ist. Sonst schreibt sie seine letzten Rechnungen fort.",
  "dialog.MergeSupplierDialog.headline": "„{name}“ zusammenführen",
  "dialog.MergeSupplierDialog.targetLabel": "Zusammenführen mit",
  "dialog.MergeSupplierDialog.targetPlaceholder": "Lieferant wählen",
  "dialog.MergeSupplierDialog.description": "{count, plural, one {Die Schreibvariante} other {Alle # Schreibvarianten}} von „{name}“ und damit alle Rechnungen gehen an den gewählten Lieferanten. „{name}“ wird danach entfernt, seine Kostenart und sein Rhythmus gehen verloren.",
  "dialog.MergeSupplierDialog.submit": "Zusammenführen",
  "dialog.SeparateSupplierSpellingDialog.headline": "Schreibvariante abtrennen",
  "dialog.SeparateSupplierSpellingDialog.description": "„{spelling}“ wird von „{name}“ getrennt und bekommt einen eigenen Lieferanten, zunächst ohne Kostenart und Rhythmus. Die Rechnungen mit dieser Schreibvariante gehen mit.",
  "dialog.SeparateSupplierSpellingDialog.submit": "Abtrennen",
  "tab.analysis.simulation": "Preissimulation",
  "tab.analysis.simulation.soon": "Kommt bald",
  "view.analysisIncome.empty": "Keine abgerechneten Einnahmen in diesem Zeitraum.",
  "view.analysisIncome.filter.all": "Alle",
  "view.analysisIncome.filter.subscriptions": "Subscriptions",
  "view.analysisIncome.filter.projects": "Projekte",
  "view.analysisIncome.filter.allServices": "Alle Services",
  "view.analysisSimulation.basis": "Basis: {month}",
  "view.analysisSimulation.reset": "Zurücksetzen",
  "view.analysisSimulation.run": "Simulieren ({count})",
  "view.analysisSimulation.runEmpty": "Simulieren",
  "view.analysisSimulation.runTitle": "{count} geänderte Pläne anwenden",
  "view.analysisSimulation.expired": "ausgelaufen",
  "view.analysisSimulation.notBilled": "im Basismonat nicht abgerechnet",
  "view.analysisSimulation.editor": "Plan-Preise",
  "view.analysisSimulation.filter": "Pläne filtern…",
  "view.analysisSimulation.kpi.baseline": "Abgerechnet (Basis)",
  "view.analysisSimulation.kpi.simulated": "Simuliert",
  "view.analysisSimulation.kpi.delta": "Differenz",
  "view.analysisSimulation.computing": "berechne…",
  "view.analysisSimulation.scenarios": "Szenarien",
  "view.analysisSimulation.scenarios.namePlaceholder": "Name des Szenarios…",
  "view.analysisSimulation.scenarios.save": "Speichern",
  "view.analysisSimulation.scenarios.saveTitle": "Aktuelle Preisänderungen als Szenario speichern",
  "view.analysisSimulation.scenarios.overwrite": "Überschreiben",
  "view.analysisSimulation.scenarios.overwriteTitle": "Szenario „{name}“ mit den aktuellen Preisänderungen überschreiben",
  "view.analysisSimulation.scenarios.empty": "Noch keine Szenarien gespeichert.",
  "view.analysisSimulation.scenarios.overrideCount": "{count, plural, one {# Änderung} other {# Änderungen}}",
  "view.analysisSimulation.scenarios.load": "Laden",
  "view.analysisSimulation.scenarios.delete": "Löschen",
  "priceField.monthly": "Monatlich",
  "priceField.hourly": "Stündlich",
  "priceField.daily": "Täglich",
  "priceField.monthlyCap": "Cap/Monat",
  "priceField.percentagePerProject": "%/Projekt",
  "priceField.outboundNetworkTransferPerGigabyte": "Transfer/GB",
  "priceField.pricePerUnit": "Pro Einheit",
  "planType.instance": "Instanzen",
  "planType.project": "Projekte",
  "planType.cluster": "Cluster",
  "planType.clusterNode": "Cluster-Nodes",
  "planType.databaseServer": "Datenbank-Server",
  "planType.redisServer": "Redis-Server",
  "planType.elasticsearchServer": "Elasticsearch-Server",
  "planType.grafanaInstance": "Grafana-Instanzen",
  "planType.support": "Support",
  "planType.meteredResource": "Verbrauchsbasiert",
  "tab.analysis.serverCost": "Server-Kosten",
  "tab.analysis.openItems": "Offene Posten",
  "view.analysisServerCost.basis": "Stand: {month} (letzte Rechnung)",
  "view.analysisServerCost.reset": "Zurücksetzen",
  "view.analysisServerCost.intro": "Tatsächliche Hetzner-Cluster-Kosten aus der letzten Rechnung. Interne Cluster (Core/Control Plane, Test) sind aus den Kunden-Zahlen ausgenommen und unten separat ausgewiesen. Trage pro Servertyp eine Preisänderung in % ein (Hetzner-Erhöhung oder Servertyp-Wechsel) — die Summe zeigt den Effekt auf den Gesamt-Deckungsbeitrag. Cluster-Overhead (Volumes, Load Balancer, Traffic, IPs, RAM-Upgrades) wird mitgezählt, aber in der Simulation konstant gehalten. Hinweis: Bei HCloud ist „Ø/Node“ durch kurzlebige Autoscaler-Nodes verzerrt; verlässlich ist die Typ-Summe.",
  "view.analysisServerCost.kpi.current": "Server-Kosten aktuell",
  "view.analysisServerCost.kpi.simulated": "Server-Kosten simuliert",
  "view.analysisServerCost.kpi.deltaCost": "Δ Kosten/Monat",
  "view.analysisServerCost.kpi.deltaMargin": "Δ Deckungsbeitrag",
  "view.analysisServerCost.byType": "Kosten nach Servertyp",
  "view.analysisServerCost.empty": "Keine Server-Daten vorhanden. Importiere zunächst Hetzner-Rechnungen.",
  "view.analysisServerCost.role.cp": "Control Plane",
  "view.analysisServerCost.role.wk": "Worker",
  "view.analysisServerCost.col.type": "Servertyp",
  "view.analysisServerCost.col.nodes": "Nodes",
  "view.analysisServerCost.col.perNode": "Ø/Node",
  "view.analysisServerCost.col.total": "Aktuell/Monat",
  "view.analysisServerCost.col.change": "Änderung",
  "view.analysisServerCost.col.newTotal": "Neu/Monat",
  "view.analysisServerCost.overhead": "Cluster-Overhead (Volumes, LB, Traffic, IPs, RAM-Upgrades)",
  "view.analysisServerCost.held": "konstant",
  "view.analysisServerCost.totalRow": "Kunden-Cluster gesamt",
  "view.analysisServerCost.internal": "Interne Infrastruktur (Core/Control Plane, Test)",
  "view.analysisServerCost.notCustomer": "nicht kundenzurechenbar",

  "view.analysisOpenItems.headline": "Offene Posten zum {date}",
  "view.analysisOpenItems.intro": "Die Forderungen, wie sie zum Stichtag standen \u2013 nicht wie sie heute aussehen. Eine Rechnung, die am Stichtag offen war und erst sp\u00e4ter bezahlt wurde, steht hier trotzdem drin, auch wenn sie inzwischen als \"Bezahlt\" gef\u00fchrt wird. Die Spalte \"Status heute\" zeigt dir den Unterschied. Rechnungen, die erst nach dem Stichtag storniert oder ausgebucht wurden, sind ebenfalls enthalten, weil sie zum Stichtag Forderungen waren.",
  "view.analysisOpenItems.cutOffDateOption": "Stichtag 31.12.{year, number, ::group-off}",
  "view.analysisOpenItems.limitToYear": "Nur Rechnungen aus {year, number, ::group-off}",
  "view.analysisOpenItems.kpi.count": "Offene Posten",
  "view.analysisOpenItems.kpi.gross": "Summe brutto",
  "view.analysisOpenItems.kpi.gross.sub": "{amount} netto",
  "view.analysisOpenItems.kpi.collectable": "Davon eingegangen oder offen",
  "view.analysisOpenItems.kpi.collectable.sub": "{count, plural, one {# Rechnung} other {# Rechnungen}}",
  "view.analysisOpenItems.kpi.writtenOff": "Davon sp\u00e4ter ausgebucht",
  "view.analysisOpenItems.kpi.writtenOff.sub": "{count, plural, one {# Rechnung} other {# Rechnungen}}",
  "view.analysisOpenItems.tableHeadline": "Rechnungen",
  "view.analysisOpenItems.empty": "Zu diesem Stichtag war keine Rechnung offen.",
  "view.analysisOpenItems.reverseInvoice": "Storno",
  "view.analysisOpenItems.col.invoiceNumber": "Nummer",
  "view.analysisOpenItems.col.invoiceDate": "Rechnungsdatum",
  "view.analysisOpenItems.col.dueDate": "F\u00e4llig",
  "view.analysisOpenItems.col.customer": "Kunde",
  "view.analysisOpenItems.col.net": "Netto",
  "view.analysisOpenItems.col.gross": "Brutto",
  "view.analysisOpenItems.col.stateToday": "Status heute",
  "view.analysisOpenItems.col.settledAt": "Ausgeglichen",
  "contact.notFound": "Kontakt nicht gefunden",
  "contact.type.team": "Team-Kontakt",
  "contact.type.individual": "Kontakt",
  "contact.salutation": "Anrede",
  "contact.salutation.mr": "Herr",
  "contact.salutation.mrs": "Frau",
  "contact.salutation.mx": "Divers",
  "contact.salutation.hello": "Hallo",
  "contact.givenName": "Vorname",
  "contact.familyName": "Nachname",
  "contact.emailAddress": "E-Mail-Adresse",
  "contact.phoneNumber": "Telefonnummer",
  "contact.teamName": "Teamname",
  "contact.preferredLanguage": "Bevorzugte Sprache",
  "contact.dataOrigin.description.question": "Woher stammen diese Kontaktdaten?",
  "contact.dataOrigin.collectedAt.question": "Wann wurden diese Daten erfasst?",
  "contact.dataOrigin.note": "Hinweise zur Herkunft der Daten",
  "contact.dataOrigin.note.placeholder": "z. B. die URL der Website, von der die Daten stammen, oder die IP-Adresse des Besuchers, der ein Kontaktformular ausgefüllt hat",
  "contact.dataOrigin.descriptions.selectDescription": "Wähle eine Beschreibung…",
  "contact.dataOrigin.descriptions.customDescription": "Eigene Beschreibung…",
  "contact.dataOrigin.descriptions.phoneCall": "Von der Person während eines Telefonanrufs bereitgestellt",
  "contact.dataOrigin.descriptions.onlineMeeting": "Von der Person während einer Online-Besprechung bereitgestellt",
  "contact.dataOrigin.descriptions.email": "Von der Person per E-Mail bereitgestellt",
  "contact.dataOrigin.descriptions.socialMedia": "Von der Person über soziale Medien bereitgestellt",
  "contact.dataOrigin.descriptions.formSubmission": "Von der Person über ein Formular bereitgestellt",
  "contact.dataOrigin.descriptions.inPersonMeeting": "Von der Person während eines persönlichen Meetings bereitgestellt",
  "contact.dataOrigin.descriptions.lookedUpInternet": "Aus öffentlichen Internetquellen recherchiert",
  "contact.attributes": "Attribute",
  "contact.attributes.addAttribute": "Attribut hinzufügen",
  "contact.attributes.noAttributes": "Keine Attribute gesetzt",
  "contact.attributes.editAttribute": "Attribut bearbeiten",
  "contact.attributes.deleteAttribute": "Attribut löschen",
  "contact.attributes.confirmDelete": "Bist du sicher, dass du dieses Attribut löschen möchtest?",
  "contact.attributes.selectAttribute": "Attribut auswählen...",
  "contact.customers": "Kunden",
  "contact.customers.noCustomers": "Keinem Kunden zugeordnet",
  "dialog.AddContactDialog.headline": "Kontakt hinzufügen",
  "dialog.AddContactDialog.submitLabel": "Hinzufügen",
  "dialog.AddContactDialog.label": "Team- oder Personen-Kontakt",
  "dialog.AddContactDialog.searchForContact": "Nach einem Kontakt suchen",
  "dialog.CreateContactDialog.createContactHeadline": "Kontakt erstellen",
  "dialog.CreateContactDialog.questionPersonOrTeam": "Ist der neue Kontakt für eine reale Person oder für ein Team oder eine Abteilung?",
  "dialog.CreateContactDialog.person": "Person",
  "dialog.CreateContactDialog.team": "Team",
  "dialog.CreatePersonContactDialog.headline": "Kontakt erstellen",
  "dialog.CreateTeamContactDialog.headline": "Team-Kontakt erstellen",
  "dialog.CreateTeamContactDialog.teamNamePlaceholder": "Backoffice-Team",
  "dialog.CreateTeamContactDialog.emailPlaceholder": "backoffice@beispiel.de",
  "dialog.CreateTeamContactDialog.phonePlaceholder": "+49 451 3050350",
  "dialog.UpdatePersonContactDialog.headline": "Kontakt aktualisieren",
  "dialog.UpdatePersonContactDialog.givenNamePlaceholder": "Jenny",
  "dialog.UpdatePersonContactDialog.familyNamePlaceholder": "Musterfrau",
  "dialog.UpdatePersonContactDialog.emailPlaceholder": "max.mustermann@beispiel.de",
  "dialog.UpdatePersonContactDialog.phonePlaceholder": "+49 451 3050350",
  "dialog.UpdateTeamContactDialog.headline": "Team-Kontakt aktualisieren",
  "dialog.UpdateTeamContactDialog.submitLabel": "Aktualisieren",
  "dialog.SetContactPreferredLanguageDialog.headline": "Bevorzugte Sprache festlegen",
  "dialog.SetContactPreferredLanguageDialog.noPreference": "Keine Präferenz",
  "dialog.UpdateContactRolesDialog.headline": "Kontaktrollen zuweisen",
  "dialog.UpdateContactRolesDialog.submitLabel": "Rollen zuweisen",
  "dialog.UpdateContactRolesDialog.instruction": "Wähle die Rollen aus, die {contact} in Bezug auf {customer} hat.",
  "dialog.UpdateContactRolesDialog.hint": "{contact} kann je nach den gewählten Rollen Zugang zu sensiblen Informationen haben.",
  "dialog.UpdateContactRolesDialog.role.primaryContact.label": "Hauptansprechpartner",
  "dialog.UpdateContactRolesDialog.role.primaryContact.description": "Ansprechpartner für alle Themen, die nicht von anderen Kontakten abgedeckt werden.",
  "dialog.UpdateContactRolesDialog.role.security.label": "Sicherheit",
  "dialog.UpdateContactRolesDialog.role.security.description": "Ansprechpartner für Sicherheits- und Datenschutzfragen sowie Schwachstellen.",
  "dialog.UpdateContactRolesDialog.role.technical.label": "Technik",
  "dialog.UpdateContactRolesDialog.role.technical.description": "Ansprechpartner für technische Ereignisse und Probleme wie Ausfälle oder Bugs.",
  "dialog.UpdateContactRolesDialog.role.billing.label": "Abrechnung",
  "dialog.UpdateContactRolesDialog.role.billing.description": "Ansprechpartner für Abrechnungs- und Zahlungsfragen, Preisaktualisierungen, Gutschriften.",
  "dialog.UpdateContactRolesDialog.role.legal.label": "Rechtliches",
  "dialog.UpdateContactRolesDialog.role.legal.description": "Ansprechpartner für Vollstreckungsmaßnahmen, Verträge und Aktualisierungen der Nutzungsbedingungen.",
  "dialog.UpdateContactRolesDialog.role.invoiceRecipient.label": "Rechnungsempfänger",
  "dialog.UpdateContactRolesDialog.role.invoiceRecipient.description": "Kontakt, der neue Rechnungen erhält. Gibt es keinen, gehen Rechnungen an die Kontakte für Abrechnung, sonst an den Hauptansprechpartner.",
  "dialog.UpdateContactRolesDialog.unknown": "Unbekannt",
  "dialog.DeleteContactDialog.headline": "Kontakt löschen",
  "dialog.DeleteContactDialog.submitLabel": "Löschen",
  "dialog.DeleteContactDialog.confirmMessage": "Kontakt \"{name}\" wirklich löschen?",
  "dialog.DeleteContactDialog.warning": "Dies löscht auch den entsprechenden Kontakt in allen mit Cabana verbundenen Anwendungen.",
  "dialog.RemoveContactDialog.headline": "Kontakt entfernen",
  "dialog.RemoveContactDialog.submitLabel": "Entfernen",
  "dialog.RemoveContactDialog.confirmMessage": "Kontakt {name} wirklich von Kunde {customer} entfernen?",
  "dialog.DeleteContactAttributeDialog.headline": "Attribut löschen",
  "dialog.DeleteContactAttributeDialog.submitLabel": "Löschen",
  "dialog.DeleteContactAttributeDialog.confirmMessage": "Attribut \"{name}\" wirklich löschen?",
  "dialog.DeleteContactAttributeDialog.warning": "Diese Aktion kann nicht rückgängig gemacht werden. Der Attributwert wird dauerhaft von diesem Kontakt entfernt.",
  "dialog.FinalizeInvoiceDialog.headline": "Rechnung finalisieren",
  "dialog.FinalizeInvoiceDialog.submitLabel": "Finalisieren",
  "dialog.FinalizeInvoiceDialog.question": "Diese Rechnung für {customer} finalisieren?",
  "dialog.FinalizeInvoiceDialog.hint": "Eine Rechnungsnummer wird vergeben und die Rechnung kann nicht mehr gelöscht werden. Nach der Finalisierung wird die Rechnung automatisch an die konfigurierten Kontakte gesendet.",
  "dialog.SendInvoiceDialog.headline": "Rechnung senden",
  "dialog.SendInvoiceDialog.submitLabel": "Senden",
  "dialog.SendInvoiceDialog.question": "Diese Rechnung an die konfigurierten Empfänger senden?",
  "dialog.SendInvoiceDialog.alreadySentHint": "Diese Rechnung wurde bereits am {date} gesendet.",
  "dialog.DeleteInvoiceDialog.headline": "Rechnung löschen",
  "dialog.DeleteInvoiceDialog.submitLabel": "Löschen",
  "dialog.DeleteInvoiceDialog.confirmMessage": "Rechnung für {customer} wirklich löschen?",
  "dialog.InitiateInvoicePaymentDialog.headline": "Zahlung veranlassen",
  "dialog.InitiateInvoicePaymentDialog.submitLabel": "Veranlassen",
  "dialog.InitiateInvoicePaymentDialog.confirmMessage": "Zahlung für Rechnung {number} jetzt veranlassen?",
  "dialog.CreateCustomerDialog.headline": "Kunde anlegen",
  "dialog.CreateCustomerDialog.customerNameLabel": "Kundenname",
  "dialog.CreateCustomerDialog.customerNamePlaceholder": "Firma GmbH",
  "dialog.CreateCustomerDialog.hint": "Der Kundenname sollte auf den offiziellen Firmennamen einschließlich der Rechtsform gesetzt werden.",
  "dialog.DeleteCustomerDialog.headline": "Kunde löschen",
  "dialog.DeleteCustomerDialog.submitLabel": "Löschen",
  "dialog.DeleteCustomerDialog.confirmMessage": "Kunde \"{name}\" wirklich löschen?",
  "dialog.DeleteCustomerDialog.warning": "Dies löscht auch den entsprechenden Kunden in allen mit Cabana verbundenen Anwendungen. Kontakte werden nicht entfernt.",
  "dialog.CreateProjectDialog.headline": "Projekt anlegen",
  "dialog.CreateProjectDialog.projectNameLabel": "Projektname",
  "dialog.CreateProjectDialog.customerAccountLabel": "Kundenkonto",
  "dialog.CreateProjectDialog.searchCustomerPlaceholder": "Nach einem Kunden suchen",
  "dialog.DeleteProjectDialog.headline": "Projekt löschen",
  "dialog.DeleteProjectDialog.submitLabel": "Löschen",
  "dialog.DeleteProjectDialog.confirmMessage": "Projekt \"{name}\" wirklich löschen?",
  "dialog.ArchiveProjectDialog.headline": "Projekt archivieren",
  "dialog.ArchiveProjectDialog.submitLabel": "Archivieren",
  "dialog.ArchiveProjectDialog.confirmMessage": "Projekt \"{name}\" wirklich archivieren?",
  "dialog.ReactivateProjectDialog.headline": "Projekt reaktivieren",
  "dialog.ReactivateProjectDialog.submitLabel": "Reaktivieren",
  "dialog.ReactivateProjectDialog.confirmMessage": "Projekt \"{name}\" wirklich reaktivieren?",
  "dialog.CreateInvoiceDialog.headline": "Rechnung anlegen",
  "dialog.CreateInvoiceDialog.customerAccountLabel": "Kundenkonto",
  "dialog.DeletePaymentMethodDialog.headline": "Zahlungsmethode löschen",
  "dialog.DeletePaymentMethodDialog.submitLabel": "Löschen",
  "dialog.DeletePaymentMethodDialog.confirmMessage": "Zahlungsmethode {type} wirklich löschen?",
  "dialog.DeletePaymentMethodDialog.warning": "Dies löscht auch die entsprechende Zahlungsmethode in allen mit Cabana verbundenen Anwendungen.",
  "dialog.SetDefaultPaymentMethodDialog.headline": "Standard-Zahlungsmethode festlegen",
  "dialog.SetDefaultPaymentMethodDialog.submitLabel": "Als Standard festlegen",
  "dialog.UpdatePaymentTermsDialog.headline": "Zahlungsbedingungen aktualisieren",
  "dialog.UpdatePaymentTermsDialog.submitLabel": "Aktualisieren",
  "dialog.UpdatePaymentTermsDialog.paymentTermsLabel": "Zahlungsbedingungen",
  "dialog.UpdatePaymentTermsDialog.paymentTerms.uponReceipt": "Bei Erhalt",
  "dialog.UpdatePaymentTermsDialog.paymentTerms.net7": "Netto 7",
  "dialog.UpdatePaymentTermsDialog.paymentTerms.net15": "Netto 15",
  "dialog.UpdatePaymentTermsDialog.paymentTerms.net30": "Netto 30",
  "dialog.UpdatePaymentTermsDialog.paymentTerms.net60": "Netto 60",
  "dialog.CancelSubscriptionDialog.headline": "Abonnement kündigen",
  "dialog.CancelSubscriptionDialog.submitLabel": "Kündigung planen",
  "dialog.CancelSubscriptionDialog.confirmMessage": "{service}-Abonnement für {reference} wirklich kündigen?",
  "dialog.CancelSubscriptionDialog.hint": "Das Abonnement von {customer} läuft am Ende dieses Monats aus.",
  "dialog.TerminateSubscriptionDialog.headline": "Abonnement beenden",
  "dialog.TerminateSubscriptionDialog.submitLabel": "Sofort beenden",
  "dialog.TerminateSubscriptionDialog.confirmMessage": "{service}-Abonnement für {reference} wirklich beenden?",
  "dialog.TerminateSubscriptionDialog.hint": "Das Abonnement von {customer} läuft sofort aus.",
  "dialog.InitiateInvoicePaymentDialog.description": "Automatische Zahlung der Rechnung {number} mit {paymentMethod} auslösen?",
  "dialog.SetDefaultPaymentMethodDialog.confirmMessage": "{paymentMethodType} mit den Endziffern {lastFourDigits} als Standard-Zahlungsmethode für {customer} festlegen?",
  "paymentMethod.SepaDebit": "SEPA-Lastschrift",
  "paymentMethod.SepaDebit.description": "SEPA-Lastschrift vom Bankkonto mit den Endziffern {lastFourDigits}",
  "paymentMethod.Card": "Kreditkarte",
  "paymentMethod.Card.description": "{cardBrand}-Karte mit den Endziffern {lastFourDigits}",
  "paymentMethod.Card.visa": "Visa-Kreditkarte",
  "paymentMethod.Card.mastercard": "Mastercard-Kreditkarte",
  "paymentMethod.unknown": "unbekannte Zahlungsmethode",
  "dialog.DeleteSettlementDialog.headline": "Abrechnung löschen",
  "dialog.DeleteSettlementDialog.submitLabel": "Löschen",
  "dialog.DeleteSettlementDialog.confirmMessage": "Abrechnung {id} wirklich löschen?",
  "validation.field.required": "Dieses Feld ist erforderlich",
  "validation.field.nameTooLong": "Dieser Name ist zu lang",
  "validation.field.nameTooShort": "Dieser Name ist zu kurz",
  "validation.field.nameContainsInvalidCharacters": "Dieser Name enthält unzulässige Zeichen",
  "validation.field.emailAddressTooLong": "Diese E-Mail-Adresse ist zu lang",
  "validation.field.emailAddressInvalid": "Das sieht nicht wie eine gültige E-Mail-Adresse aus",
  "validation.field.phoneNumberTooLong": "Diese Telefonnummer ist zu lang",
  "validation.field.phoneNumberInvalid": "Das sieht nicht wie eine gültige Telefonnummer aus",
  "validation.field.descriptionTooLong": "Diese Beschreibung ist zu lang",
  "validation.field.collectedAtInvalid": "Ungültiges Datum",
  "validation.field.collectedAtInFuture": "Das Datum darf nicht in der Zukunft sein",
  "validation.field.noteTooLong": "Diese Notiz ist zu lang",
  "validation.field.noteContainsInvalidCharacters": "Diese Notiz enthält unzulässige Zeichen (z.B. < oder >)",
  "errors.failedToDeleteContact": "Fehler beim Löschen des Kontakts.",
  "errors.failedToRemoveContact": "Fehler beim Entfernen des Kontakts.",
  "errors.failedToAddContact": "Fehler beim Hinzufügen des Kontakts.",
  "errors.failedToUpdateContactRoles": "Fehler beim Aktualisieren der Kontaktrollen.",
  "errors.failedToDeleteContactAttribute": "Fehler beim Löschen des Attributs.",
  "errors.failedToCreateTeamContact": "Fehler beim Erstellen des Team-Kontakts.",
  "errors.failedToUpdatePersonContact": "Fehler beim Aktualisieren des Kontakts.",
  "errors.failedToUpdateTeamContact": "Fehler beim Aktualisieren des Team-Kontakts.",
  "errors.failedToSetPreferredLanguage": "Fehler beim Festlegen der bevorzugten Sprache.",
  "errors.failedToFinalizeInvoice": "Fehler beim Finalisieren der Rechnung.",
  "errors.failedToSendInvoice": "Fehler beim Senden der Rechnung.",
  "errors.failedToDeleteInvoice": "Fehler beim Löschen der Rechnung.",
  "errors.failedToInitiatePayment": "Fehler beim Einleiten der Zahlung.",
  "errors.failedToCreateCustomer": "Fehler beim Anlegen des Kunden.",
  "errors.failedToDeleteCustomer": "Fehler beim Löschen des Kunden.",
  "errors.failedToCreateProject": "Fehler beim Anlegen des Projekts.",
  "errors.failedToDeleteProject": "Fehler beim Löschen des Projekts.",
  "errors.failedToArchiveProject": "Fehler beim Archivieren des Projekts.",
  "errors.failedToReactivateProject": "Fehler beim Reaktivieren des Projekts.",
  "errors.failedToCreateInvoice": "Fehler beim Anlegen der Rechnung.",
  "errors.failedToDeletePaymentMethod": "Fehler beim Löschen der Zahlungsmethode.",
  "errors.failedToSetDefaultPaymentMethod": "Fehler beim Festlegen der Standard-Zahlungsmethode.",
  "errors.failedToUpdatePaymentTerms": "Fehler beim Aktualisieren der Zahlungsbedingungen.",
  "errors.failedToCancelSubscription": "Fehler beim Kündigen des Abonnements.",
  "errors.failedToTerminateSubscription": "Fehler beim Beenden des Abonnements.",
  "errors.failedToDeleteSettlement": "Fehler beim Löschen der Abrechnung.",
  "errors.failedToCreateAttributeDefinition": "Fehler beim Erstellen der Attributdefinition.",
  "errors.failedToDeleteAttributeDefinition": "Fehler beim Löschen der Attributdefinition.",
  "errors.failedToCreateReverseInvoice": "Fehler beim Erstellen der Stornorechnung.",
  "errors.failedToCreateSubscription": "Fehler beim Erstellen des Abonnements.",
  "errors.failedToCreateTermsAndConditionsDocument": "Fehler beim Erstellen des Dokuments für Geschäftsbedingungen.",
  "errors.failedToSetUpPaymentMethod": "Fehler beim Einrichten der Zahlungsmethode.",
  "errors.failedToSetUpStripePayment": "Fehler beim Einrichten der Stripe-Zahlung.",
  "errors.failedToUpdateCustomerOrderNotes": "Fehler beim Aktualisieren der Kundenbestellnotizen.",
  "errors.failedToUpdatePurchaseOrderReference": "Fehler beim Aktualisieren der Bestellreferenz.",
  "button.cancel": "Abbrechen",
  "button.confirm": "Bestätigen",
  "button.create": "Erstellen",
  "combobox.loading": "Wird geladen …",
  "combobox.noResults": "Keine Treffer",
  "button.save": "Speichern",
  "button.saving": "Speichern…",
  "button.edit": "Bearbeiten",
  "button.delete": "Löschen",
  "button.update": "Aktualisieren",
  "button.add": "Hinzufügen",
  "button.remove": "Entfernen",
  "button.submit": "Absenden",
  "button.show": "Anzeigen",
  "validation.field.attributeNamePattern": "Name muss dem Muster \"namespace.attribut_name\" folgen (Kleinbuchstaben, Zahlen, Unterstriche)",
  "validation.field.labelTooShort": "Label ist zu kurz",
  "validation.field.labelTooLong": "Label ist zu lang",
  "validation.field.invalidType": "Ungültiger Typ",
  "validation.field.titleTooShort": "Titel ist zu kurz",
  "validation.field.titleTooLong": "Titel ist zu lang",
  "validation.field.invalidCode": "Ungültiger Code",
  "validation.field.invalidVersion": "Ungültige Version",
  "validation.field.invalidUri": "Ungültige URI",
  "validation.field.invalidDate": "Ungültiges Datum",
  "attributeDefinition.name": "Name",
  "attributeDefinition.name.hint": "Verwende das Format namespace.attribut_name (z. B. platform.last_login, custom.industry)",
  "attributeDefinition.label": "Label",
  "attributeDefinition.label.placeholder": "Letztes Login-Datum",
  "attributeDefinition.label.hint": "Für Menschen lesbares Label für dieses Attribut",
  "attributeDefinition.type": "Typ",
  "attributeDefinition.type.string": "String",
  "attributeDefinition.type.integer": "Integer",
  "attributeDefinition.type.date": "Datum",
  "attributeDefinition.type.boolean": "Boolean",
  "attributeDefinition.entityTypes": "Unterstützte Entity-Typen",
  "attributeDefinition.entityTypes.contact": "Kontakt",
  "attributeDefinition.entityTypes.account": "Konto",
  "attributeDefinition.entityTypes.hint": "Wähle aus, welche Entity-Typen dieses Attribut verwenden können",
  "dialog.CreateAttributeDefinitionDialog.headline": "Attributdefinition erstellen",
  "dialog.DeleteAttributeDefinitionDialog.headline": "Attributdefinition löschen",
  "dialog.DeleteAttributeDefinitionDialog.confirmMessage": "Attributdefinition \"{name}\" wirklich löschen?",
  "dialog.DeleteAttributeDefinitionDialog.warning": "Diese Aktion kann nicht rückgängig gemacht werden. Vorhandene Attributwerte bleiben erhalten, aber es können keine neuen Werte für dieses Attribut gesetzt werden.",
  "dialog.CreateReverseInvoiceDialog.headline": "Stornorechnung",
  "dialog.CreateReverseInvoiceDialog.question": "Stornorechnung für {invoiceNumber} erstellen?",
  "dialog.CreateReverseInvoiceDialog.hint": "Eine neue Stornorechnung wird als Entwurf erstellt. Es wird nichts an {customer} gesendet und keine Zahlungen werden storniert, bis die Stornorechnung finalisiert wurde.",
  "dialog.CreateSubscriptionDialog.headline": "Abonnement erstellen",
  "subscription.customerAccount": "Kundenkonto",
  "subscription.subscriptionService": "Abonnementdienst",
  "subscription.subscriptionServiceReference": "Abonnementdienst-Referenz",
  "subscription.subscriptionServiceReference.placeholder": "Zum Beispiel die UUID einer Beach-Organisation",
  "subscription.subscriptionServiceReferenceLabel": "Abonnementdienst-Referenz-Label",
  "subscription.subscriptionServiceReferenceLabel.placeholder": "Zum Beispiel der Name einer Beach-Organisation",
  "subscription.subscriptionServiceReferenceUri": "Abonnementdienst-Referenz-URI",
  "subscription.orderedAt": "Bestelldatum",
  "subscription.activateAt": "Startdatum",
  "subscription.settlementType": "Abrechnungstyp",
  "subscription.customerOrderNotes": "Kundenbestellnotizen",
  "subscription.customerOrderNotes.placeholder": "Bestellt von Jenny Musterfrau",
  "subscription.customerOrderNotes.editPlaceholder": "z. B. bestellt von Julia Higgins",
  "subscription.purchaseOrderReference": "Bestellreferenz",
  "subscription.purchaseOrderReference.editPlaceholder": "z. B. PO-12348-887ah8",
  "dialog.CreateTermsAndConditionsDocumentDialog.headline": "Geschäftsbedingungen erstellen",
  "termsAndConditions.code": "Code",
  "termsAndConditions.title": "Titel",
  "termsAndConditions.title.placeholder": "Allgemeine Geschäftsbedingungen",
  "termsAndConditions.version": "Version",
  "termsAndConditions.uri": "URI",
  "termsAndConditions.startDate": "Startdatum",
  "termsAndConditions.publishDate": "Veröffentlichungsdatum",
  "termsAndConditions.published": "Veröffentlicht",
  "dialog.SetUpOnAccountPaymentMethodDialog.headline": "Zahlung auf Rechnung hinzufügen",
  "paymentMethod.paymentTerms": "Zahlungsbedingungen",
  "paymentMethod.paymentTerms.uponReceipt": "Netto sofort bei Erhalt",
  "paymentMethod.paymentTerms.net7": "Netto 7 Tage",
  "paymentMethod.paymentTerms.net15": "Netto 15 Tage",
  "paymentMethod.paymentTerms.net30": "Netto 30 Tage",
  "paymentMethod.paymentTerms.net60": "Netto 60 Tage",
  "dialog.SetUpStripePaymentMethodDialog.headline": "Zahlungsmethode einrichten",
  "language.german": "Deutsch",
  "language.english": "Englisch",
  "view.customerAccount.headline": "Kontoinformationen",
  "customer.field.customerNumber": "Kundennummer",
  "customer.field.customerName": "Kundenname",
  "customer.field.customerName.placeholder": "Firma GmbH",
  "customer.field.businessAddress": "Geschäftsadresse",
  "customer.field.addressLine1.placeholder": "Straße und Hausnummer",
  "customer.field.addressLine2.placeholder": "Zusätzliche Adressinformationen",
  "customer.field.postalCode.placeholder": "Postleitzahl",
  "customer.field.city.placeholder": "Stadt",
  "customer.field.vatId": "USt-IdNr.",
  "customer.field.vatId.placeholder": "DE999999999",
  "customer.field.taxStatus": "Steuerstatus",
  "customer.field.preferredLanguage": "Bevorzugte Sprache",
  "customer.taxStatus.unknown": "Unbekannt",
  "customer.taxStatus.regular": "Regulär",
  "customer.taxStatus.exempt": "Befreit",
  "customer.taxStatus.reverseCharge": "Reverse Charge",
  "validation.field.customerNameTooShort": "Dieser Kundenname ist zu kurz",
  "validation.field.customerNameTooLong": "Dieser Kundenname ist zu lang",
  "validation.field.vatIdTooShort": "Diese USt-IdNr. ist zu kurz",
  "validation.field.vatIdTooLong": "Diese USt-IdNr. ist zu lang",
  "validation.field.vatIdInvalid": "Das sieht nicht wie eine gültige USt-IdNr. aus",
  "validation.field.invalidTaxStatus": "Ungültiger Steuerstatus",
  "validation.field.businessNameTooShort": "Dieser Firmenname ist zu kurz",
  "validation.field.businessNameTooLong": "Dieser Firmenname ist zu lang",
  "validation.field.postalCodeInvalid": "Ungültige Postleitzahl",
  "validation.field.cityInvalid": "Ungültiger Stadtname",
  "validation.field.orderNotesTooLong": "Die Bestellnotizen sind zu lang",
  "validation.field.invalidOrderNotes": "Ungültige Bestellnotizen",
  "validation.field.invalidPurchaseOrderReference": "Ungültige Bestellreferenz",
  "errors.failedToUpdateCustomerName": "Fehler beim Aktualisieren des Kundennamens.",
  "errors.failedToUpdateBusinessAddress": "Fehler beim Aktualisieren der Geschäftsadresse.",
  "errors.failedToUpdateVatId": "Fehler beim Aktualisieren der USt-IdNr.",
  "errors.failedToUpdateTaxStatus": "Fehler beim Aktualisieren des Steuerstatus.",
  "errors.failedToUpdatePreferredLanguage": "Fehler beim Aktualisieren der bevorzugten Sprache.",
  "button.deleteAccount": "Konto löschen",
  "button.downloadPdf": "PDF herunterladen",
  "button.finalize": "Finalisieren...",
  "button.refresh": "Aktualisieren",
  "button.reverseInvoice": "Rechnung stornieren…",
  "button.initiatePayment": "Zahlung veranlassen…",
  "button.sendToCustomer": "An Kunde senden…",
  "button.deleteProject": "Projekt löschen",
  "button.archiveProject": "Projekt archivieren",
  "button.reactivateProject": "Projekt reaktivieren",
  "invoice.field.documentLanguage": "Dokumentsprache",
  "invoice.field.invoiceNumber": "Rechnungsnummer",
  "invoice.field.invoiceDate": "Rechnungsdatum",
  "invoice.field.relatedInvoice": "Zugehörige Rechnung",
  "invoice.field.dueDate": "Fälligkeitsdatum",
  "invoice.field.periodOfPerformance": "Leistungszeitraum",
  "invoice.field.purchaseOrderReference": "Bestellreferenz",
  "invoice.field.customerOrderNotes": "Kundenbestellnotizen",
  "invoice.field.state": "Status",
  "invoice.field.totalGrossAmount": "Bruttobetrag",
  "invoice.document.outdated": "Das Dokument wird gerade neu erstellt. Angezeigt wird noch die vorherige Fassung.",
  "invoice.document.notRenderedYet": "Für diese Rechnung wurde noch kein Dokument erstellt.",
  "invoice.document.unavailable": "Das Dokument dieser Rechnung ist derzeit nicht abrufbar.",
  "invoice.document.loadFailed": "Die Vorschau konnte nicht geladen werden.",
  "pdfViewer.pageOfPages": "Seite {current} von {total}",
  "invoice.section.notes": "Notizen",
  "invoice.section.attachments": "Anhänge",
  "invoice.section.payment": "Zahlung",
  "invoice.attachment.upload": "Anhänge hochladen",
  "invoice.attachment.dragAndDrop": "oder hierher ziehen",
  "invoice.attachment.sizeLimit": "PDF bis zu 10 MB",
  "invoice.email.wasSentOn": "wurde gesendet am",
  "invoice.email.label": "Rechnungs-E-Mail",
  "invoice.payment.paidOn": "bezahlt am",
  "invoice.payment.inProgressSince": "Zahlung veranlasst am",
  "invoice.payment.scheduledFor": "geplant für",
  "invoice.payment.dueOn": "fällig am",
  "invoice.payment.net7Days": "Netto 7 Tage",
  "invoice.payment.net15Days": "Netto 15 Tage",
  "invoice.payment.net30Days": "Netto 30 Tage",
  "invoice.payment.net60Days": "Netto 60 Tage",
  "invoice.payment.paymentMethod": "Zahlungsmethode",
  "invoice.payment.succeededAt": "erfolgreich am",
  "invoice.payment.wasCanceledAt": "wurde storniert am",
  "invoice.payment.wasCreatedAt": "wurde erstellt am",
  "invoice.payment.createdAt": "erstellt am",
  "invoice.payment.paymentIntent": "Zahlungsabsicht",
  "invoice.payment.charge": "Buchung",
  "invoice.payment.refund": "Rückerstattung",
  "invoice.payment.chargeDisputed": "Diese Buchung wurde angefochten.",
  "invoice.payment.chargeRefunded": "Diese Buchung wurde erstattet.",
  "invoice.payment.sepaDirectDebitFrom": "SEPA-Lastschrift vom Bankkonto mit den Endziffern {lastFourDigits}.",
  "invoice.payment.chargingCard": "Belastung der {cardBrand}-Karte mit den Endziffern {lastFourDigits}.",
  "invoice.payment.chargeFailure.referToCustomer": "Die Bank hat zu dieser Ablehnung keine weiteren Details mitgeteilt.",
  "invoice.payment.chargeFailure.expiredCard": "Die Bank meldet dass die Kreditkarte abgelaufen sei.",
  "invoice.payment.chargeFailure.cardDecline": "Die Bank hat die Zahlung abgelehnt.",
  "invoice.payment.chargeFailure.incorrectNumber": "Die Bank meldet dass die Kartennummer falsch sei.",
  "errors.failedToUpdateTimeOfPerformance": "Fehler beim Aktualisieren des Leistungszeitraums.",
  "errors.failedToDownloadPdf": "Fehler beim Herunterladen des PDF.",
  "errors.failedToRefreshPdf": "Fehler beim Aktualisieren des PDF.",
  "project.field.projectName": "Projektname",
  "project.field.documentLanguage": "Dokumentsprache",
  "project.field.billing": "Abrechnung",
  "project.field.billingMode": "Abrechnungsmodus",
  "project.field.hourlyRate": "Stundensatz (in Euro-Cent)",
  "project.field.fixedFee": "Festpreis (in Euro-Cent)",
  "project.field.purchaseOrderReference": "Bestellreferenz",
  "project.field.customerOrderNotes": "Kundenbestellnotizen",
  "project.billingMode.nonBillable": "Nicht abrechenbar",
  "project.billingMode.timeAndMaterials": "Zeit und Material",
  "project.billingMode.fixedFee": "Festpreis",
  "project.billing.timeAndMaterialsCharge": "Zeit und Material, {hourlyRate} pro Stunde",
  "project.billing.fixedFeeCharge": "Festpreis, {fixedFee} insgesamt",
  "errors.failedToRenameProject": "Fehler beim Umbenennen des Projekts.",
  "errors.failedToUpdateProjectBilling": "Fehler beim Aktualisieren der Projektabrechnung.",
  "navigation.dashboard": "Dashboard",
  "navigation.sidebar": "Seitenleiste",
  "navigation.closeSidebar": "Seitenleiste schließen",
  "navigation.collapseSidebar": "Seitenleiste einklappen",
  "navigation.expandSidebar": "Seitenleiste ausklappen",
  "list.invoice.header.state": "Status",
  "list.invoice.header.invoiceDate": "Rg. Datum",
  "list.invoice.header.dueDate": "Fälligkeit",
  "list.invoice.header.invoiceNumber": "Rg. Nummer",
  "list.invoice.header.customer": "Kunde",
  "list.invoice.header.total": "Rg. Betrag",
  "list.invoice.action.delete": "Rechnung löschen",
  "list.invoice.action.edit": "Rechnung bearbeiten",
  "list.invoice.action.show": "Rechnung anzeigen",
  "list.invoice.state.draft": "Entwurf",
  "list.invoice.state.invoiceNumberPending": "Nummer ausstehend",
  "list.invoice.state.open": "Offen",
  "list.invoice.state.paid": "Bezahlt",
  "list.invoice.state.refunded": "Rückerstattet",
  "list.invoice.state.reversed": "Storniert",
  "list.invoice.state.uncollectible": "Uneinbringlich",
  "list.invoice.state.void": "Ungültig",
  "list.invoice.legend.title": "Legende",
  "list.invoice.legend.paymentIsFailing": "Zahlung schlägt fehl",
  "list.invoice.legend.paymentIsOverdue14": "14 Tage oder mehr überfällig",
  "list.invoice.legend.paymentIsOverdue30": "30 Tage oder mehr überfällig",
  "list.project.header.state": "Status",
  "list.project.header.projectNumber": "Projektnr.",
  "list.project.header.project": "Projekt",
  "list.project.header.customer": "Kunde",
  "list.project.header.rate": "Satz",
  "list.project.state.archived": "Archiviert",
  "list.project.state.active": "Aktiv",
  "list.project.billingMode.nonBillable": "Nicht abrechenbar",
  "list.project.billingMode.fixedFee": "Festpreis",
  "list.project.action.show": "Projekt anzeigen",
  "list.settlement.header.state": "Status",
  "list.settlement.header.cutOffDate": "Stichtag",
  "list.settlement.header.customer": "Kunde",
  "list.settlement.header.service": "Dienst",
  "list.settlement.header.description": "Beschreibung",
  "list.settlement.header.netTotal": "Nettobetrag",
  "header.invoice.type.reverse": "Stornorechnung",
  "header.invoice.type.invoice": "Rechnung",
  "header.project.billingMode.timeAndMaterials": "Zeit und Material",
  "header.project.billingMode.fixedFee": "Festpreis",
  "header.project.billingMode.nonBillable": "Nicht abrechenbar",
  "header.project.state.archived": "Archiviert",
  "header.project.state.active": "Aktiv",
  "header.settlement.status.open": "Offen",
  "header.settlement.status.invoiced": "Abgerechnet",
  "header.settlement.status.finalized": "Finalisiert",
  "header.settlement.status.closed": "Geschlossen",
  "header.settlement.status.unknown": "Unbekannt",
  "search.label": "Suche",
  "search.placeholder": "Nach irgendetwas suchen",
  "profile.headline": "Benutzerprofil",
  "profile.fullName": "Vollständiger Name",
  "profile.namePlaceholder": "Name",
  "profile.emailAddress": "E-Mail-Adresse",
  "profile.emailPlaceholder": "E-Mail",
  "button.loadMore": "Mehr laden",
  "button.deleteContact": "Kontakt löschen",
  "view.contactData.name": "Name",
  "view.dataProtection.dataOrigins": "Datenherkunft",
  "view.customerContacts.headline": "Kundenkontakte",
  "view.customerContacts.noContacts": "Keine Kontakte",
  "view.customerContacts.noContactsDescription": "Weise diesem Kunden den ersten Kontakt zu.",
  "view.customerContacts.addContact": "Kontakt hinzufügen",
  "view.customerContacts.people": "Personen",
  "view.customerContacts.teams": "Teams",
  "view.payment.headline": "Zahlungsmethoden",
  "view.payment.noPaymentMethods": "Keine Zahlungsmethoden gefunden",
  "view.payment.noPaymentMethodsDescription": "Richte eine Kreditkarte oder ein SEPA-Lastschriftmandat für diesen Kunden ein",
  "view.payment.addCardOrSepa": "Karte oder SEPA hinzufügen",
  "view.payment.addOnAccount": "Auf Rechnung hinzufügen",
  "view.projectPayment.headline": "Zahlungsmethode",
  "view.projectPayment.notImplemented": "Benutzerdefinierte Zahlungsmethoden für Projekte sind noch nicht implementiert.",
  "list.paymentMethod.header.type": "Typ",
  "list.paymentMethod.header.number": "Nummer",
  "list.paymentMethod.header.details": "Details",
  "list.paymentMethod.header.status": "Status",
  "list.paymentMethod.status.default": "Standard",
  "paymentMethod.OnAccount": "Auf Rechnung",
  "view.contacts.headline": "Kontakte",
  "view.contacts.createButton": "Kontakt erstellen",
  "view.contacts.searchPlaceholder": "Kontakte durchsuchen",
  "view.subscriptions.headline": "Abonnements",
  "view.subscriptions.createButton": "Abonnement erstellen",
  "view.subscriptions.searchPlaceholder": "Abonnements durchsuchen",
  "view.subscriptions.terminateButton": "Abonnement beenden",
  "view.subscriptions.cancelButton": "Abonnement kündigen",
  "view.projects.headline": "Projekte",
  "view.projects.createButton": "Projekt erstellen",
  "view.projects.searchPlaceholder": "Projekte durchsuchen",
  "view.customers.headline": "Kunden",
  "view.customers.createButton": "Kunde erstellen",
  "view.customers.searchPlaceholder": "Kunden durchsuchen",
  "view.settlements.headline": "Abrechnungen",
  "view.settlements.searchPlaceholder": "Abrechnungen durchsuchen",
  "tab.invoices.outgoing": "Ausgangsrechnungen",
  "tab.invoices.incoming": "Eingangsrechnungen",
  "tab.invoices.suppliers": "Lieferanten",
  "view.invoices.headline": "Ausgangsrechnungen",
  "view.invoices.createButton": "Rechnung erstellen",
  "view.invoices.searchPlaceholder": "Rechnungen durchsuchen",
  "view.invoices.searchLabel": "Suche",
  "view.invoices.filter.active": "Aktiv",
  "view.invoices.filter.overdue": "Überfällig",
  "view.invoices.filter.done": "Erledigt",
  "view.invoices.filter.all": "Alle",
  "view.configurationContracts.headline": "Geschäftsbedingungen",
  "view.configurationContracts.createButton": "Geschäftsbedingungen erstellen",
  "view.configurationContracts.ariaLabel": "Geschäftsbedingungen",
  "view.configurationContracts.table.id": "ID",
  "view.configurationContracts.table.code": "Code",
  "view.configurationContracts.table.title": "Titel",
  "view.configurationContracts.table.version": "Version",
  "view.configurationContracts.table.uri": "URI",
  "view.configurationContracts.table.startDate": "Startdatum",
  "view.configurationContracts.noDocuments": "Keine Geschäftsbedingungen gefunden.",
  "view.configurationContracts.loading": "Wird geladen...",
  "view.configurationAttributeDefinitions.headline": "Attributdefinitionen",
  "view.configurationAttributeDefinitions.createButton": "Attributdefinition erstellen",
  "view.configurationAttributeDefinitions.ariaLabel": "Attributdefinitionen",
  "view.configurationAttributeDefinitions.table.name": "Name",
  "view.configurationAttributeDefinitions.table.label": "Label",
  "view.configurationAttributeDefinitions.table.type": "Typ",
  "view.configurationAttributeDefinitions.table.entityTypes": "Entity-Typen",
  "view.configurationAttributeDefinitions.noDefinitions": "Keine Attributdefinitionen gefunden.",
  "view.subscription.status": "Status",
  "view.subscription.customerAccount": "Kundenkonto",
  "view.subscription.service": "Dienst",
  "view.subscription.serviceReference": "Dienstreferenz",
  "view.subscription.notFound": "Abonnement nicht gefunden",
  "view.subscription.assigningNumber": "Rechnungsnummer wird zugewiesen",
  "view.subscription.panel.headline": "Abonnement",
  "view.subscription.status.expiredAt": "Abgelaufen am {date}",
  "view.subscription.status.canceledWillExpireAt": "Gekündigt, läuft ab am {date}",
  "view.subscription.status.activeSince": "Aktiv seit {date}",
  "list.subscription.state.scheduled": "Geplant",
  "list.subscription.state.active": "Aktiv",
  "list.subscription.state.canceled": "Gekündigt",
  "list.subscription.state.expired": "Abgelaufen",
  "common.loading": "Wird geladen...",
  "common.unsavedChanges": "Ungespeicherte Änderungen",
  "contact.emailAddress.buttonTitle": "E-Mail-Adresse",
  "contact.phoneNumber.buttonTitle": "Telefonnummer",
  "detailedContactList.editRoles": "Rollen bearbeiten",
  "attributeDefinition.deleteButton": "Attributdefinition löschen",
  "dialog.placeholder.manual": "Manuell",
  "dialog.placeholder.purchaseOrder": "PO-1234567",
  "dialog.placeholder.datetime": "JJJJ-MM-TT HH:MM:SS",
  "dialog.placeholder.confirmProjectName": "Gib den Projektnamen zur Bestätigung ein",
  "dialog.placeholder.enterValue": "Wert eingeben...",
  "dialog.placeholder.enterNumber": "Nummer eingeben...",
  "breadcrumb.configuration": "Konfiguration",
  "breadcrumb.contacts": "Kontakte",
  "breadcrumb.customers": "Kunden",
  "breadcrumb.projects": "Projekte",
  "breadcrumb.settlements": "Abrechnungen",
  "tab.configuration": "Konfiguration",
  "tab.marketing.emails": "E-Mails",
  "tab.marketing.lists": "Listen",
  "tab.marketing.templates": "Vorlagen",
  "tab.contracts": "Verträge",
  "tab.attributes": "Attribute",
  "tab.finance": "Finanzen",
  "tab.contact": "Kontakt",
  "tab.dataProtection": "Datenschutz",
  "tab.customer": "Kunde",
  "tab.contacts": "Kontakte",
  "tab.payment": "Zahlung",
  "tab.project": "Projekt",
  "tab.activities": "Aktivitäten",
  "tab.english": "Englisch",
  "tab.german": "Deutsch",
  "activity.recentActivity": "Letzte Aktivitäten",
  "activity.noActivities": "Noch keine Aktivitäten",
  "activity.today": "Heute",
  "activity.yesterday": "Gestern",
  "activity.viewTicket": "Ticket ansehen",
  "activity.viewAll": "Alle Aktivitäten anzeigen",
  "activity.cabana.contact.created": "Kontakt wurde erstellt",
  "activity.cabana.contact.updated": "Kontakt wurde aktualisiert",
  "activity.cabana.contact.assigned_to_customer": "Wurde dem Kundenkonto {customerName} zugewiesen",
  "activity.cabana.contact.removed_from_customer": "Wurde vom Kundenkonto {customerName} entfernt",
  "activity.cabana.contact.role_assigned": "Rolle {roleIdentifier} wurde für {customerName} zugewiesen",
  "activity.cabana.contact.role_unassigned": "Rolle {roleIdentifier} wurde für {customerName} entfernt",
  "activity.cabana.contact.attribute_changed": "Attribut {attributeName} wurde geändert",
  "activity.cabana.contact.attribute_removed": "Attribut {attributeName} wurde entfernt",
  "activity.cabana.contact.email_changed": "E-Mail-Adresse wurde geändert",
  "activity.zammad.ticket.created": "Neues Ticket: {ticketTitle} (#{ticketNumber})",
  "activity.zammad.ticket.updated": "Ticket #{ticketNumber} wurde aktualisiert",
  "activity.zammad.ticket.closed": "Ticket \"{ticketTitle}\" wurde geschlossen (#{ticketNumber})",
  "activity.zammad.ticket.reopened": "Ticket \"{ticketTitle}\" wurde wieder geöffnet (#{ticketNumber})",
  "activity.zammad.ticket.article_added": "Neue Antwort auf Ticket \"{ticketTitle}\" (#{ticketNumber})",
  "activity.cabana.customer_account.created": "Kundenkonto wurde erstellt",
  "activity.cabana.customer_account.renamed": "Kundenkonto wurde umbenannt",
  "activity.cabana.customer_account.address_updated": "Geschäftsadresse wurde aktualisiert",
  "activity.cabana.customer_account.tax_info_updated": "USt-IdNr. wurde aktualisiert",
  "activity.cabana.customer_account.tax_status_updated": "Steuerstatus wurde auf {taxStatus} geändert",
  "activity.cabana.customer_account.payment_method_changed": "Standard-Zahlungsmethode wurde geändert",
  "activity.cabana.customer_account.language_updated": "Bevorzugte Sprache wurde auf {language} geändert",
  "activity.cabana.customer_account.contact_added": "Kontakt {contactName} wurde hinzugefügt",
  "activity.cabana.customer_account.contact_removed": "Kontakt {contactName} wurde entfernt",
  "activity.cabana.customer_account.contact_role_assigned": "Rolle {roleIdentifier} wurde {contactName} zugewiesen",
  "activity.cabana.customer_account.contact_role_unassigned": "Rolle {roleIdentifier} wurde von {contactName} entfernt",
  "activity.cabana.list.subscribed": "Kontakt wurde zur Liste \"{mailingListName}\" hinzugefügt",
  "activity.cabana.list.unsubscribed": "Kontakt hat sich von Liste \"{mailingListName}\" abgemeldet",
  "activity.cabana.list.removed": "Kontakt wurde von Liste \"{mailingListName}\" entfernt",
  "activity.cabana.list.resubscribed": "Kontakt wurde erneut zur Liste \"{mailingListName}\" hinzugefügt",
  "activity.cabana.email.sent": "E-Mail \"{subject}\" wurde gesendet",
  "activity.cabana.email.delivered": "E-Mail \"{subject}\" wurde zugestellt",
  "activity.cabana.email.bounced": "E-Mail \"{subject}\" konnte nicht zugestellt werden (Bounce)",
  "activity.cabana.email.failed": "E-Mail \"{subject}\" konnte nicht gesendet werden",

  "navigation.marketingEmails": "Marketing-E-Mails",
  "navigation.mailingLists": "Listen",
  "navigation.emailTemplates": "E-Mail-Vorlagen",

  "view.marketingEmails.headline": "Marketing-E-Mails",
  "view.marketingEmails.createButton": "Marketing-E-Mail erstellen",
  "view.marketingEmails.searchPlaceholder": "Marketing-E-Mails suchen",
  "view.marketingEmails.noMarketingEmails": "Keine Marketing-E-Mails gefunden",
  "view.marketing.headline": "Marketing",

  "view.mailingLists.headline": "Listen",
  "view.mailingLists.createButton": "Liste erstellen",
  "view.mailingLists.searchPlaceholder": "Listen suchen",
  "view.mailingLists.noMailingLists": "Keine Listen gefunden",

  "view.emailTemplates.headline": "E-Mail-Vorlagen",
  "view.emailTemplates.createButton": "Vorlage erstellen",
  "view.emailTemplates.searchPlaceholder": "Vorlagen suchen",
  "view.emailTemplates.noEmailTemplates": "Keine E-Mail-Vorlagen gefunden",
  "view.emailTemplates.showUsedOneTime": "Verwendete Einmalvorlagen anzeigen",

  "breadcrumb.marketingEmails": "Marketing-E-Mails",
  "breadcrumb.marketing": "Marketing",
  "breadcrumb.mailingLists": "Listen",
  "breadcrumb.emailTemplates": "E-Mail-Vorlagen",
  "breadcrumb.templates": "Vorlagen",

  "tab.marketingEmail.overview": "Übersicht",
  "tab.marketingEmail.details": "Details",
  "tab.marketingEmail.delivery": "Zustellung",
  "tab.marketingEmail.delivery.locked": "Verfügbar nach Versand",
  "tab.marketingEmail.unsubscribes": "Abmeldungen",
  "tab.marketingEmail.unsubscribes.locked": "Verfügbar nach Versand",
  "tab.mailingList.details": "Details",
  "tab.mailingList.members": "Mitglieder",
  "tab.emailTemplate.details": "Details",

  "marketingEmail.notFound": "Marketing-E-Mail nicht gefunden",
  "marketingEmail.status.draft": "Entwurf",
  "marketingEmail.status.sending": "Wird gesendet",
  "marketingEmail.status.sent": "Gesendet",
  "marketingEmail.status.partiallySent": "Teilweise gesendet",
  "marketingEmail.field.name": "Name",
  "marketingEmail.field.status": "Status",
  "marketingEmail.field.mailingList": "Liste",
  "marketingEmail.field.mailingListPlaceholder": "Nach Liste suchen",
  "marketingEmail.field.emailTemplate": "E-Mail-Vorlage",
  "marketingEmail.field.emailTemplatePlaceholder": "Nach E-Mail-Vorlage suchen",
  "marketingEmail.field.emailLayout": "E-Mail-Layout",
  "marketingEmail.field.emailLayoutPlaceholder": "Nach Layout suchen",
  "marketingEmail.field.sender": "Absender",
  "marketingEmail.field.senderName": "Absendername",
  "marketingEmail.field.senderEmail": "Absender-E-Mail",
  "marketingEmail.field.replyToEmail": "Antwort-E-Mail",
  "marketingEmail.field.subject": "Betreff",
  "marketingEmail.field.preheader": "Vorschautext",
  "marketingEmail.field.recipientCount": "Anzahl Empfänger",
  "marketingEmail.section.recipients": "Empfänger",
  "marketingEmail.section.template": "Vorlage",
  "marketingEmail.section.layout": "Layout",
  "marketingEmail.section.sender": "Absender",
  "marketingEmail.section.content": "Inhalt",
  "marketingEmail.subscribers": "Abonnenten",
  "marketingEmail.noMailingList": "Keine Liste ausgewählt",
  "marketingEmail.noTemplate": "Keine Vorlage ausgewählt",
  "marketingEmail.noLayout": "Kein Layout ausgewählt",
  "marketingEmail.defaultLayout": "(Standard-Layout)",
  "marketingEmail.noSender": "Kein Absender konfiguriert",
  "marketingEmail.noSubject": "Kein Betreff konfiguriert",
  "marketingEmail.panel.info": "Marketing-E-Mail",
  "marketingEmail.panel.email": "E-Mail",
  "marketingEmail.panel.content": "Inhalt",
  "marketingEmail.field.recipients": "Empfänger",
  "marketingEmail.field.replyTo": "Antwort an",
  "marketingEmail.preview.plainText": "Text",
  "marketingEmail.preview.preheader": "Vorschautext",
  "marketingEmail.preview.noTemplate": "Wähle eine E-Mail-Vorlage aus, um eine Vorschau zu sehen",
  "marketingEmail.preview.noPreheader": "Kein Vorschautext",
  "marketingEmail.preview.title": "Vorschau",
  "marketingEmail.preview.error": "Vorschau konnte nicht geladen werden",

  "mailingList.notFound": "Liste nicht gefunden",
  "mailingList.status.archived": "Archiviert",
  "mailingList.field.name": "Name",
  "mailingList.field.description": "Beschreibung",
  "mailingList.field.subscribedCount": "Abonniert",
  "mailingList.field.unsubscribedCount": "Abgemeldet",
  "mailingList.field.createdAt": "Erstellt",
  "mailingList.noDescription": "Keine Beschreibung",
  "mailingList.noMembers": "Keine Mitglieder in dieser Liste",
  "mailingList.members": "Mitglieder",
  "mailingList.member.status.subscribed": "Abonniert",
  "mailingList.member.status.unsubscribed": "Abgemeldet",
  "mailingList.field.subscriptionReason": "Abonnement-Begründung",
  "mailingList.field.type": "Typ",
  "mailingList.field.criterion": "Kriterium",
  "mailingList.type.static": "Statisch (manuelle Mitglieder)",
  "mailingList.type.dynamic": "Dynamisch (nach Kontakt-Attribut)",
  "mailingList.criterion.operator.equals": "ist gleich",
  "mailingList.criterion.operator.exists": "ist gesetzt",
  "mailingList.criterion.value.true": "wahr",
  "mailingList.criterion.value.false": "falsch",
  "mailingList.criterion.condition.equals": "{attribute} = {value}",
  "mailingList.criterion.condition.exists": "{attribute} ist gesetzt",
  "mailingList.dynamicMembers": "Aktuelle Mitglieder ({count})",
  "mailingList.dynamicMembers.loading": "Mitglieder werden geladen …",
  "mailingList.dynamicMembers.truncated": "Es werden nur die ersten {count} Treffer angezeigt.",
  "mailingList.unsubscribedMembers": "Abgemeldete Kontakte ({count})",
  "mailingList.noUnsubscribedMembers": "Keine abgemeldeten Kontakte",
  "mailingList.subscriptionReason.defaultText.de": "Du bekommst diese E-Mail, weil du {listName} abonniert hast.",
  "mailingList.subscriptionReason.defaultText.en": "You are receiving this email because you subscribed to {listName}.",

  "dialog.EditSubscriptionReasonDialog.headline": "Abonnement-Begründung bearbeiten",

  "errors.failedToUpdateSubscriptionReason": "Die Abonnement-Begründung konnte nicht aktualisiert werden",

  "emailTemplate.notFound": "E-Mail-Vorlage nicht gefunden",
  "emailTemplate.field.name": "Name",
  "emailTemplate.field.usageCount": "Verwendet in Marketing-E-Mails",
  "emailTemplate.field.createdAt": "Erstellt",
  "emailTemplate.field.updatedAt": "Zuletzt aktualisiert",
  "emailTemplate.field.content": "Inhalt",
  "emailTemplate.field.htmlContent": "HTML-Inhalt",
  "emailTemplate.field.textContent": "Nur-Text-Inhalt",
  "emailTemplate.section.content": "Inhalt",
  "emailTemplate.hasContent": "Inhalt konfiguriert",
  "emailTemplate.noContent": "Kein Inhalt konfiguriert",
  "emailTemplate.tab.preview": "Vorschau",
  "emailTemplate.tab.edit": "Bearbeiten",
  "emailTemplate.tab.html": "HTML",
  "emailTemplate.preview.title": "Vorschau",
  "emailTemplate.preview.plainText": "Nur Text",
  "emailTemplate.preview.noContent": "Kein Inhalt zur Vorschau",
  "emailTemplate.action.startEditing": "Bearbeitung starten",
  "emailTemplate.placeholder.htmlContent": "Gib hier den HTML-Inhalt deiner E-Mail ein...",
  "emailTemplate.placeholder.textContent": "Gib hier die Nur-Text-Version ein...",
  "emailTemplate.generateFromHtml": "Aus HTML generieren",

  "richTextEditor.paragraph": "Absatz",
  "richTextEditor.heading1": "Überschrift 1",
  "richTextEditor.heading2": "Überschrift 2",
  "richTextEditor.heading3": "Überschrift 3",
  "richTextEditor.bold": "Fett",
  "richTextEditor.italic": "Kursiv",
  "richTextEditor.bulletList": "Aufzählung",
  "richTextEditor.orderedList": "Nummerierte Liste",
  "richTextEditor.addLink": "Link hinzufügen",
  "richTextEditor.removeLink": "Link entfernen",
  "richTextEditor.insertLink": "Einfügen",
  "richTextEditor.insertVariable": "Variable einfügen",

  "templateVariable.group.contact": "Kontakt",
  "templateVariable.group.customerAccount": "Kunde",
  "templateVariable.group.other": "Sonstige",
  "templateVariable.contact.givenName": "Vorname",
  "templateVariable.contact.familyName": "Nachname",
  "templateVariable.contact.fullName": "Vollständiger Name",
  "templateVariable.contact.emailAddress": "E-Mail-Adresse",
  "templateVariable.contact.salutation": "Anrede",
  "templateVariable.contact.teamName": "Teamname",
  "templateVariable.customerAccount.customerName": "Kundenname",
  "templateVariable.subscriptionPreferencesUrl": "Link zu Einstellungen",

  "list.marketingEmail.header.status": "Status",
  "list.marketingEmail.header.name": "Name",
  "list.marketingEmail.header.mailingList": "Liste",
  "list.marketingEmail.header.template": "Vorlage",
  "list.marketingEmail.header.recipients": "Empfänger",
  "list.marketingEmail.header.sentAt": "Gesendet",
  "list.marketingEmail.action.show": "Marketing-E-Mail anzeigen",

  "list.mailingList.header.name": "Name",
  "list.mailingList.header.description": "Beschreibung",
  "list.mailingList.header.subscribed": "Abonniert",
  "list.mailingList.header.unsubscribed": "Abgemeldet",
  "list.mailingList.header.createdAt": "Erstellt",
  "list.mailingList.action.show": "Liste anzeigen",

  "list.mailingListMember.header.status": "Status",
  "list.mailingListMember.header.name": "Name",
  "list.mailingListMember.header.email": "E-Mail",
  "list.mailingListMember.header.subscribedAt": "Abonniert",
  "list.mailingListMember.header.unsubscribedAt": "Abgemeldet",

  "list.emailTemplate.header.name": "Name",
  "list.emailTemplate.header.type": "Typ",
  "list.emailTemplate.header.usageCount": "Verwendung",
  "list.emailTemplate.header.createdAt": "Erstellt",
  "list.emailTemplate.header.updatedAt": "Aktualisiert",
  "list.emailTemplate.action.show": "Vorlage anzeigen",
  "list.emailTemplate.type.reusable": "Wiederverwendbar",
  "list.emailTemplate.type.oneTime": "Einmalig",
  "list.emailTemplate.type.used": "Verwendet",

  "dialog.CreateMarketingEmailDialog.headline": "Marketing-E-Mail erstellen",
  "dialog.CreateMarketingEmailDialog.nameLabel": "Name",
  "dialog.CreateMarketingEmailDialog.namePlaceholder": "Newsletter Januar 2026",

  "dialog.ArchiveMarketingEmailDialog.headline": "Marketing-E-Mail archivieren",
  "dialog.ArchiveMarketingEmailDialog.confirmMessage": "Möchtest du die Marketing-E-Mail \"{name}\" wirklich archivieren?",

  "dialog.LaunchMarketingEmailDialog.headline": "Marketing-E-Mail senden",
  "dialog.LaunchMarketingEmailDialog.confirmMessage": "Du bist dabei, diese E-Mail an alle Empfänger zu senden. Diese Aktion kann nicht rückgängig gemacht werden.",
  "dialog.LaunchMarketingEmailDialog.warning": "E-Mails werden sofort versendet.",
  "dialog.LaunchMarketingEmailDialog.noRecipients": "Diese Marketing-E-Mail hat keine Empfänger. Bitte wähle eine Liste mit mindestens einem Abonnenten aus.",

  "dialog.SendMarketingEmailTestEmailDialog.headline": "Test-E-Mail senden",
  "dialog.SendMarketingEmailTestEmailDialog.description": "Sende eine Test-E-Mail für \"{name}\", um den Inhalt vor dem Versand zu überprüfen.",
  "dialog.SendMarketingEmailTestEmailDialog.recipientEmailLabel": "Empfänger-E-Mail",
  "dialog.SendMarketingEmailTestEmailDialog.sampleContactLabel": "Beispielkontakt",
  "dialog.SendMarketingEmailTestEmailDialog.sampleContactPlaceholder": "Nach Kontakt suchen...",
  "dialog.SendMarketingEmailTestEmailDialog.sampleContactHint": "Die Daten des Beispielkontakts werden verwendet, um Platzhalter in der E-Mail-Vorlage zu füllen. Wenn kein Kontakt ausgewählt ist, werden Platzhalterdaten verwendet.",

  "dialog.CreateMailingListDialog.headline": "Liste erstellen",
  "dialog.CreateMailingListDialog.nameLabel": "Name",
  "dialog.CreateMailingListDialog.namePlaceholder": "Newsletter-Abonnenten",
  "dialog.CreateMailingListDialog.descriptionLabel": "Beschreibung",
  "dialog.CreateMailingListDialog.descriptionPlaceholder": "Abonnenten unseres monatlichen Newsletters",
  "dialog.CreateMailingListDialog.typeLabel": "Listentyp",
  "dialog.CreateMailingListDialog.attributeLabel": "Kontakt-Attribut",
  "dialog.CreateMailingListDialog.attributePlaceholder": "Attribut wählen …",
  "dialog.CreateMailingListDialog.operatorLabel": "Bedingung",
  "dialog.CreateMailingListDialog.valueLabel": "Wert",
  "dialog.CreateMailingListDialog.valuePlaceholder": "z. B. true",
  "dialog.EditMailingListCriterionDialog.headline": "Kriterium bearbeiten",

  "dialog.CreateEmailTemplateDialog.headline": "E-Mail-Vorlage erstellen",
  "dialog.CreateEmailTemplateDialog.nameLabel": "Vorlagenname",
  "dialog.CreateEmailTemplateDialog.namePlaceholder": "Monatliche Newsletter-Vorlage",
  "dialog.CreateEmailTemplateDialog.reusableLabel": "Vorlagentyp",
  "dialog.CreateEmailTemplateDialog.reusableCheckboxLabel": "Wiederverwendbare Vorlage",
  "dialog.CreateEmailTemplateDialog.reusableHelp": "Wiederverwendbare Vorlagen können für mehrere Marketing-E-Mails verwendet werden. Einmalvorlagen verschwinden aus der Auswahl, nachdem ihre Marketing-E-Mail gesendet wurde.",

  "dialog.DeleteEmailTemplateDialog.headline": "E-Mail-Vorlage löschen",
  "dialog.DeleteEmailTemplateDialog.confirmMessage": "Möchtest du die E-Mail-Vorlage \"{name}\" wirklich löschen?",

  "button.archive": "Archivieren",
  "button.launch": "Starten",
  "button.sendTestEmail": "Test-E-Mail senden",
  "button.sendTestEmail.disabledNoLayout": "Test-E-Mail senden (wähle zuerst ein Layout im Template)",
  "button.launchMarketingEmail": "E-Mail senden",
  "button.archiveMarketingEmail": "Marketing-E-Mail archivieren",
  "button.archiveMailingList": "Liste archivieren",
  "button.restoreMailingList": "Liste wiederherstellen",
  "button.deleteEmailTemplate": "Vorlage löschen",

  "errors.failedToCreateMarketingEmail": "Marketing-E-Mail konnte nicht erstellt werden.",
  "errors.failedToRenameMarketingEmail": "Marketing-E-Mail konnte nicht umbenannt werden.",
  "errors.failedToArchiveMarketingEmail": "Marketing-E-Mail konnte nicht archiviert werden.",
  "errors.failedToLaunchMarketingEmail": "Marketing-E-Mail konnte nicht gesendet werden.",
  "errors.failedToSendTestEmail": "Test-E-Mail konnte nicht gesendet werden.",
  "errors.failedToAssignMailingList": "Liste konnte nicht zugewiesen werden.",
  "errors.failedToAssignTemplate": "Vorlage konnte nicht zugewiesen werden.",
  "errors.failedToAssignLayout": "Layout konnte nicht zugewiesen werden.",
  "errors.failedToConfigureSender": "Absender konnte nicht konfiguriert werden.",
  "errors.senderFieldsRequired": "Absendername und E-Mail-Adresse sind erforderlich.",
  "errors.failedToConfigureContent": "Inhalt konnte nicht konfiguriert werden.",
  "errors.failedToCreateMailingList": "Liste konnte nicht erstellt werden.",
  "errors.failedToUpdateMailingListCriterion": "Kriterium konnte nicht aktualisiert werden.",
  "errors.failedToResubscribeContact": "Kontakt konnte nicht wieder angemeldet werden.",
  "errors.failedToRenameMailingList": "Liste konnte nicht umbenannt werden.",
  "errors.failedToUpdateMailingListDescription": "Beschreibung der Liste konnte nicht aktualisiert werden.",
  "errors.failedToArchiveMailingList": "Liste konnte nicht archiviert werden.",
  "errors.failedToRestoreMailingList": "Liste konnte nicht wiederhergestellt werden.",
  "errors.failedToCreateEmailTemplate": "E-Mail-Vorlage konnte nicht erstellt werden.",
  "errors.failedToRenameEmailTemplate": "E-Mail-Vorlage konnte nicht umbenannt werden.",
  "errors.failedToUpdateEmailTemplateContent": "Inhalt der E-Mail-Vorlage konnte nicht aktualisiert werden.",
  "errors.failedToDeleteEmailTemplate": "E-Mail-Vorlage konnte nicht gelöscht werden.",
  "validation.field.invalidEmail": "Ungültige E-Mail-Adresse",

  "tab.marketing": "Marketing",
  "contact.marketing.lists": "Listen",
  "contact.marketing.noLists": "Dieser Kontakt ist in keiner Liste",
  "contact.marketing.header.listName": "Listenname",
  "contact.marketing.header.subscribedAt": "Angemeldet seit",
  "contact.marketing.header.unsubscribedAt": "Abgemeldet am",
  "contact.marketing.header.status": "Status",
  "button.addToList": "Zu Liste hinzufügen",
  "button.removeFromList": "Von Liste entfernen",
  "button.resubscribe": "Wieder anmelden",
  "dialog.SubscribeContactToListDialog.headline": "Zu Liste hinzufügen",
  "dialog.SubscribeContactToListDialog.listLabel": "Liste",
  "dialog.SubscribeContactToListDialog.listPlaceholder": "Nach einer Liste suchen",
  "dialog.RemoveContactFromListDialog.headline": "Von Liste entfernen",
  "dialog.RemoveContactFromListDialog.message": "Möchtest du den Kontakt von der Liste \"{listName}\" entfernen?",
  "errors.failedToSubscribeToList": "Fehler beim Hinzufügen zur Liste.",
  "errors.failedToRemoveFromList": "Fehler beim Entfernen von der Liste.",
  "button.addContactToList": "Kontakt hinzufügen",
  "dialog.AddContactToMailingListDialog.headline": "Kontakt zur Liste hinzufügen",
  "dialog.AddContactToMailingListDialog.contactLabel": "Kontakt",
  "dialog.AddContactToMailingListDialog.contactPlaceholder": "Nach einem Kontakt suchen",
  "loading": "Wird geladen...",

  "marketingEmail.delivery.statistics": "Zustellungsstatistik",
  "marketingEmail.delivery.list": "Zustellungen",
  "marketingEmail.delivery.noDeliveries": "Keine Zustellungen vorhanden",

  "delivery.status.queued": "In Warteschlange",
  "delivery.status.sent": "Gesendet",
  "delivery.status.delivered": "Zugestellt",
  "delivery.status.bounced": "Zurückgewiesen",
  "delivery.status.failed": "Fehlgeschlagen",

  "delivery.stat.total": "Gesamt",
  "delivery.stat.queued": "In Warteschlange",
  "delivery.stat.sent": "Gesendet",
  "delivery.stat.delivered": "Zugestellt",
  "delivery.stat.bounced": "Zurückgewiesen",
  "delivery.stat.failed": "Fehlgeschlagen",

  "delivery.column.status": "Status",
  "delivery.column.recipient": "Empfänger",
  "delivery.column.contact": "Kontakt",
  "delivery.column.sentAt": "Gesendet am",
  "delivery.column.deliveredAt": "Zugestellt am",
  "delivery.column.details": "Details",

  "marketingEmail.unsubscribes.title": "Abmeldungen",
  "marketingEmail.unsubscribes.noUnsubscribes": "Keine Abmeldungen",
  "marketingEmail.unsubscribes.noUnsubscribesDescription": "Es haben sich noch keine Kontakte über diese Marketing-E-Mail von der Liste abgemeldet.",
  "marketingEmail.unsubscribes.column.contact": "Kontakt",
  "marketingEmail.unsubscribes.column.unsubscribedAt": "Abgemeldet am",
  "marketingEmail.unsubscribes.column.reason": "Grund",

  "marketingEmail.preview.subject": "Betreff",
  "marketingEmail.preview.noSubject": "Kein Betreff",

  "emailTemplate.field.primaryLanguage": "Primäre Sprache",
  "emailTemplate.field.subject": "Betreff",
  "emailTemplate.field.preheader": "Vorschautext",
  "emailTemplate.field.language": "Sprache",
  "emailTemplate.section.variants": "Sprachvarianten",
  "emailTemplate.primaryBadge": "Primär",
  "emailTemplate.noSubject": "Kein Betreff",
  "emailTemplate.placeholder.subject": "Gib den E-Mail-Betreff ein...",
  "emailTemplate.placeholder.preheader": "Vorschautext, der in E-Mail-Clients angezeigt wird...",
  "emailTemplate.subtitle": "Erstellt {createdAt} · {usageCount, plural, =0 {Nicht verwendet} =1 {1 Marketing-E-Mail} other {# Marketing-E-Mails}}",
  "emailTemplate.badge.draft": "Entwurf",
  "emailTemplate.badge.notUsed": "Nicht verwendet",
  "emailTemplate.badge.usedInMarketingEmails": "{count, plural, =1 {1 Marketing-E-Mail} other {# Marketing-E-Mails}}",

  "button.addLanguage": "Sprache hinzufügen",
  "button.setAsPrimary": "Als Primär festlegen",
  "button.removeLanguage": "Sprache entfernen",
  "button.close": "Schließen",

  "dialog.AddEmailTemplateVariantDialog.headline": "Sprachvariante hinzufügen",
  "dialog.AddEmailTemplateVariantDialog.description": "Füge dieser E-Mail-Vorlage eine neue Sprachvariante hinzu.",
  "dialog.AddEmailTemplateVariantDialog.allLanguagesUsed": "Alle verfügbaren Sprachen haben bereits Varianten.",

  "errors.failedToAddEmailTemplateVariant": "Sprachvariante konnte nicht hinzugefügt werden.",
  "errors.failedToUpdateEmailTemplateVariant": "Sprachvariante konnte nicht aktualisiert werden.",
  "errors.failedToRemoveVariant": "Sprachvariante konnte nicht entfernt werden.",
  "errors.failedToSetPrimaryLanguage": "Primäre Sprache konnte nicht festgelegt werden.",
  "errors.cannotRemoveLastVariant": "Die letzte Sprachvariante kann nicht entfernt werden.",
  "errors.failedToAssignLayoutToTemplate": "Layout konnte nicht der Vorlage zugewiesen werden.",

  "emailTemplate.section.layout": "Layout",
  "emailTemplate.field.emailLayout": "E-Mail-Layout",
  "emailTemplate.preview.withLayout": "Vorschau",
  "emailLayout.badge.default": "Standard",

  "tab.marketing.layouts": "Layouts",
  "navigation.emailLayouts": "E-Mail-Layouts",
  "breadcrumb.layouts": "Layouts",

  "view.emailLayouts.headline": "E-Mail-Layouts",
  "view.emailLayouts.createLayout": "Layout erstellen",
  "view.emailLayouts.noEmailLayouts": "Keine E-Mail-Layouts gefunden",

  "view.emailLayout.notFound": "E-Mail-Layout nicht gefunden",
  "view.emailLayout.defaultLayout": "Standard-Layout",
  "view.emailLayout.htmlContent": "HTML-Inhalt",
  "view.emailLayout.htmlContentDescription": "Das Layout-HTML wird um den E-Mail-Inhalt herum dargestellt. Verwende {{content}} als Platzhalter für den Template-Inhalt.",
  "view.emailLayout.availableVariables": "Verfügbare Variablen:",
  "view.emailLayout.variable.content": "Hier wird der Template-Inhalt eingefügt (Pflichtfeld)",
  "view.emailLayout.variable.footerNote": "Inhalt der Fußzeile (Listen-Einstellungen und rechtliche Hinweise)",
  "view.emailLayout.textContent": "Nur-Text-Layout",
  "view.emailLayout.textContentDescription": "Das Nur-Text-Layout wird um den E-Mail-Inhalt herum dargestellt. Verwende {{content}} als Platzhalter für den Template-Inhalt.",
  "emailTemplate.layoutPreviewHint": "Die grauen Bereiche zeigen den Layout-Text, der deinen Inhalt umschließt.",

  "emailTemplate.section.images": "Bilder",
  "emailTemplate.images.upload": "Bild hochladen",
  "emailTemplate.images.dragAndDrop": "oder per Drag & Drop ablegen",
  "emailTemplate.images.supportedFormats": "JPEG, PNG oder GIF bis zu 10 MB",
  "emailTemplate.images.uploading": "Wird hochgeladen...",
  "emailTemplate.images.uploadError": "Fehler beim Hochladen des Bildes",
  "emailTemplate.images.readError": "Fehler beim Lesen der Datei",
  "emailTemplate.images.deleteError": "Fehler beim Löschen des Bildes",
  "emailTemplate.images.copyUrl": "URL kopieren",
  "emailTemplate.images.copied": "Kopiert!",
  "emailTemplate.images.noImages": "Keine Bilder hochgeladen",

  "list.emailLayout.header.name": "Name",
  "list.emailLayout.header.isDefault": "Standard",
  "list.emailLayout.header.createdAt": "Erstellt",
  "list.emailLayout.header.updatedAt": "Aktualisiert",
  "list.emailLayout.default": "Standard",
  "list.emailLayout.action.show": "Layout anzeigen",

  "dialog.CreateEmailLayoutDialog.headline": "E-Mail-Layout erstellen",
  "dialog.CreateEmailLayoutDialog.nameLabel": "Layout-Name",
  "dialog.CreateEmailLayoutDialog.namePlaceholder": "Flownative Standard",

  "dialog.RenameEmailLayoutDialog.headline": "E-Mail-Layout umbenennen",
  "dialog.RenameEmailLayoutDialog.nameLabel": "Neuer Name",

  "dialog.SetEmailLayoutAsDefaultDialog.headline": "Als Standard festlegen",
  "dialog.SetEmailLayoutAsDefaultDialog.confirmMessage": "Möchtest du \"{name}\" als Standard-Layout festlegen? Das aktuelle Standard-Layout wird nicht mehr als Standard verwendet.",

  "dialog.DeleteEmailLayoutDialog.headline": "E-Mail-Layout löschen",
  "dialog.DeleteEmailLayoutDialog.confirmMessage": "Möchtest du das E-Mail-Layout \"{name}\" wirklich löschen?",

  "action.rename": "Umbenennen",
  "action.setAsDefault": "Als Standard festlegen",
  "action.delete": "Löschen",
  "action.save": "Speichern",
  "action.editTitle": "Titel bearbeiten",
  "action.copyIdentifier": "Klicken zum Kopieren der Kennung",

  "errors.failedToCreateEmailLayout": "E-Mail-Layout konnte nicht erstellt werden.",
  "errors.failedToRenameEmailLayout": "E-Mail-Layout konnte nicht umbenannt werden.",
  "errors.failedToSetEmailLayoutAsDefault": "Standard-Layout konnte nicht festgelegt werden.",
  "errors.failedToDeleteEmailLayout": "E-Mail-Layout konnte nicht gelöscht werden.",
  "errors.failedToUpdateEmailLayoutContent": "Layout-Inhalt konnte nicht aktualisiert werden.",

  "emailBlock.type.heading": "Überschrift",
  "emailBlock.type.paragraph": "Absatz",
  "emailBlock.type.imageFullWidth": "Bild",
  "emailBlock.type.imageFullWidthWithOverlay": "Bild mit Overlay",
  "emailBlock.palette.title": "Block hinzufügen",
  "emailBlock.palette.hint": "Klicken, um einen Block hinzuzufügen",
  "emailBlock.empty": "Klicke links auf einen Block-Typ, um Inhalt hinzuzufügen",
  "emailBlock.action.moveUp": "Nach oben verschieben",
  "emailBlock.action.moveDown": "Nach unten verschieben",
  "emailBlock.action.delete": "Block löschen",
  "emailBlock.placeholder.heading": "Überschrift eingeben...",
  "emailBlock.placeholder.paragraph": "Text eingeben...",
  "emailBlock.editor.empty": "Block auswählen zum Bearbeiten",

  "emailBlock.image.selectImage": "Bild",
  "emailBlock.image.uploadImage": "Bild hochladen",
  "emailBlock.image.replaceImage": "Bild ersetzen",
  "emailBlock.image.altText": "Alternativtext",
  "emailBlock.image.altTextPlaceholder": "Beschreibung des Bildes...",
  "emailBlock.imageOverlay.headline": "Überschrift",
  "emailBlock.imageOverlay.headlinePlaceholder": "Überschrift eingeben...",
  "emailBlock.imageOverlay.subHeadline": "Unterüberschrift",
  "emailBlock.imageOverlay.subHeadlinePlaceholder": "Unterüberschrift eingeben...",
  "tab.analysis.forecast": "Vorschau",
  "view.analysisForecast.area.accounts": "Kontoauszüge",
  "view.analysisForecastAccounts.headline": "Bankkonten",
  "view.analysisForecastAccounts.empty": "Noch kein Bankkonto vorhanden. Lege es unter <link>Konfiguration → Finanzen</link> an, dann kannst du hier seine Kontoauszüge hochladen.",
  "view.analysisForecastAccounts.col.name": "Konto",
  "view.analysisForecastAccounts.col.currentBalance": "Kontostand",
  "view.analysisForecastAccounts.col.coveredUntil": "Kontoauszug bis",
  "view.analysisForecastAccounts.col.lastUpload": "Letzter Upload",
  "view.analysisForecastAccounts.lastUpload.details": "{count, plural, one {# Buchung} other {# Buchungen}} vom {start} bis {end}, von {user}",
  "view.analysisForecastAccounts.noUpload": "Noch kein Kontoauszug hochgeladen",
  "view.analysisForecastAccounts.action.upload": "Kontoauszug hochladen",
  "view.configurationBankAccounts.headline": "Bankkonten",
  "view.configurationBankAccounts.createButton": "Bankkonto hinzufügen",
  "view.configurationBankAccounts.empty": "Noch keine Bankkonten. Lege ein Konto mit seinem Kontostand an einem Stichtag an, dann kannst du in der Vorschau seine Kontoauszüge hochladen.",
  "view.configurationBankAccounts.col.name": "Konto",
  "view.configurationBankAccounts.col.anchor": "Bekannter Kontostand",
  "view.configurationBankAccounts.anchor": "{amount} am {date}",
  "view.configurationBankAccounts.action.edit": "Name und bekannten Kontostand bearbeiten",
  "errors.failedToCreateBankAccount": "Das Bankkonto konnte nicht angelegt werden.",
  "errors.failedToRenameBankAccount": "Das Bankkonto konnte nicht umbenannt werden.",
  "errors.failedToSetBankAccountAnchor": "Der bekannte Kontostand des Bankkontos konnte nicht geändert werden.",
  "validation.field.invalidAmount": "Das ist kein Betrag, nutze ein Format wie 1.234,56",
  "dialog.EditBankAccountDialog.createHeadline": "Bankkonto hinzufügen",
  "dialog.EditBankAccountDialog.editHeadline": "Bankkonto bearbeiten",
  "dialog.EditBankAccountDialog.nameLabel": "Name",
  "dialog.EditBankAccountDialog.anchorDateLabel": "Stand am",
  "dialog.EditBankAccountDialog.anchorBalanceLabel": "Bekannter Kontostand am Ende dieses Tages (EUR)",
  "dialog.EditBankAccountDialog.anchorDescription": "Ein Kontostand, den du sicher kennst, z. B. aus dem Kontoauszug oder der BWA. Cabana rechnet von hier aus mit den hochgeladenen Umsätzen vor und zurück. Wenn du ihn änderst, gilt das sofort für alle Tage.",
  "dialog.UploadBankStatementDialog.headline": "Kontoauszug für {name} hochladen",
  "dialog.UploadBankStatementDialog.description": "Wähle den CSV-Export der Bank. Die Datei wird einmal gelesen und danach verworfen. Gespeichert werden nur die Tagessummen, sie ersetzen die Tage, die die Datei abdeckt.",
  "dialog.UploadBankStatementDialog.coveredUntil": "Kontoauszug bis",
  "dialog.UploadBankStatementDialog.coveredUntil.hint": "Der letzte Tag, den der Kontoauszug abdeckt, meist der Tag des Exports. Leer lassen für den gestrigen Tag. Tage ohne Buchungen bis zu diesem Tag gelten als buchungsfrei.",
  "dialog.UploadBankStatementDialog.submit": "Hochladen",
  "dialog.UploadBankStatementDialog.unreadable": "Die Datei konnte nicht gelesen werden.",
  "dialog.UploadBankStatementDialog.result.period": "Zeitraum",
  "dialog.UploadBankStatementDialog.result.coveredUntil": "Kontoauszug bis",
  "dialog.UploadBankStatementDialog.result.bookingCount": "Buchungen",
  "dialog.UploadBankStatementDialog.result.balance": "Errechneter Kontostand am {date}",
  "dialog.UploadBankStatementDialog.result.otherShare": "Anteil „Sonstiges“ an den Abflüssen",
  "dialog.UploadBankStatementDialog.result.adjustRules": "Regeln anpassen",
  "view.configurationBankTransactionRules.headline": "Regeln für Kontoumsätze",
  "view.configurationBankTransactionRules.addButton": "Regel hinzufügen",
  "view.configurationBankTransactionRules.description": "Regeln ordnen die Buchungen eines hochgeladenen Kontoauszugs einer Gruppe zu. Sie werden von oben nach unten geprüft, die erste passende Regel gewinnt. Ohne passende Regel zählen Zahlungen an bekannte Lieferanten als Lieferanten, andere Eingänge als Kundenzahlungen und andere Abflüsse als Sonstiges. Geänderte Regeln wirken ab dem nächsten Upload. Um sie auf bereits hochgeladene Buchungen anzuwenden, lade die Datei dieses Zeitraums erneut hoch.",
  "view.configurationBankTransactionRules.empty": "Noch keine Regeln.",
  "view.configurationBankTransactionRules.col.condition": "Wenn",
  "view.configurationBankTransactionRules.col.direction": "Buchungen",
  "view.configurationBankTransactionRules.col.group": "Gruppe",
  "view.configurationBankTransactionRules.condition": "{field} enthält <b>{text}</b>",
  "view.configurationBankTransactionRules.action.moveUp": "Nach oben",
  "view.configurationBankTransactionRules.action.moveDown": "Nach unten",
  "view.configurationBankTransactionRules.action.edit": "Regel bearbeiten",
  "view.configurationBankTransactionRules.action.delete": "Regel entfernen",
  "bankTransactionRuleField.COUNTERPARTY_NAME": "Name der Gegenpartei",
  "bankTransactionRuleField.PURPOSE": "Verwendungszweck",
  "bankTransactionDirection.BOTH": "Ein- und Ausgänge",
  "bankTransactionDirection.IN": "Nur Eingänge",
  "bankTransactionDirection.OUT": "Nur Abflüsse",
  "bankTransactionGroup.CUSTOMER_PAYMENTS": "Kundenzahlungen",
  "bankTransactionGroup.SUPPLIERS": "Lieferanten",
  "bankTransactionGroup.SALARIES": "Gehälter und Sozialabgaben",
  "bankTransactionGroup.TAX_OFFICE": "Finanzamt",
  "bankTransactionGroup.FINANCING": "Finanzierung",
  "bankTransactionGroup.TRANSFER": "Umbuchung zwischen eigenen Konten",
  "bankTransactionGroup.OTHER": "Sonstiges",
  "forecastCategory.REVENUE": "Umsatz",
  "forecastCategory.OTHER_OPERATING_INCOME": "Sonstige betriebliche Erlöse",
  "forecastCategory.SUPPLIERS": "Lieferanten",
  "forecastCategory.PERSONNEL": "Personal",
  "forecastCategory.DEPRECIATION": "Abschreibungen",
  "forecastCategory.INCOME_TAXES": "Steuern vom Einkommen und Ertrag",
  "forecastCategory.FINANCING": "Finanzierung",
  "forecastCategory.OTHER": "Sonstiges",
  "errors.failedToAddBankTransactionRule": "Die Regel konnte nicht hinzugefügt werden.",
  "errors.failedToChangeBankTransactionRule": "Die Regel konnte nicht geändert werden.",
  "errors.failedToRemoveBankTransactionRule": "Die Regel konnte nicht entfernt werden.",
  "errors.failedToMoveBankTransactionRule": "Die Regel konnte nicht verschoben werden.",
  "dialog.EditBankTransactionRuleDialog.addHeadline": "Regel hinzufügen",
  "dialog.EditBankTransactionRuleDialog.editHeadline": "Regel bearbeiten",
  "dialog.EditBankTransactionRuleDialog.fieldLabel": "Prüfe",
  "dialog.EditBankTransactionRuleDialog.containedTextLabel": "Enthält",
  "dialog.EditBankTransactionRuleDialog.directionLabel": "Gilt für",
  "dialog.EditBankTransactionRuleDialog.groupLabel": "Gruppe",
  "dialog.EditBankTransactionRuleDialog.description": "Groß- und Kleinschreibung spielen keine Rolle. Eine neue Regel steht hinter den bestehenden. Schiebe sie nach oben, damit sie vor anderen Regeln gewinnt. Sie wirkt ab dem nächsten Upload.",
  "dialog.DeleteBankTransactionRuleDialog.headline": "Regel entfernen",
  "dialog.DeleteBankTransactionRuleDialog.confirmMessage": "Möchtest du die Regel für „{text}“ wirklich entfernen? Bereits hochgeladene Buchungen behalten ihre Gruppe, bis ihr Zeitraum erneut hochgeladen wird.",
  "view.analysisForecast.area.bwa": "BWA",
  "validation.field.invalidMonth": "Verwende das Format JJJJ-MM, z. B. 2026-08",
  "errors.failedToRecordBwaMonth": "Die BWA-Werte konnten nicht gespeichert werden",
  "errors.failedToRemoveBwaMonth": "Die BWA-Werte konnten nicht entfernt werden",
  "view.analysisForecastBwa.headline": "BWA-Werte pro Monat",
  "view.analysisForecastBwa.recordButton": "Monat eintragen",
  "view.analysisForecastBwa.description": "Werte aus der BWA, von Hand eingetragen. Alle Beträge sind netto. Ein Monat mit Werten wird in der Ergebnistabelle als „mit BWA“ geführt. Die Kontostände werden mit den aus den hochgeladenen Kontoauszügen errechneten Kontoständen verglichen, eine Abweichung ist hervorgehoben.",
  "view.analysisForecastBwa.empty": "Noch keine BWA-Werte.",
  "view.analysisForecastBwa.missing": "Für {months} fehlen noch BWA-Werte. Diese Monate gelten bis dahin als „ohne BWA“.",
  "view.analysisForecastBwa.col.month": "Monat",
  "view.analysisForecastBwa.col.revenue": "Umsatzerlöse",
  "view.analysisForecastBwa.col.otherOperatingIncome": "Sonstige betriebliche Erlöse",
  "view.analysisForecastBwa.col.personnelCosts": "Personal",
  "view.analysisForecastBwa.col.hostingAndLicences": "Hosting, Lizenzen",
  "view.analysisForecastBwa.col.otherCosts": "Sonstige Kosten",
  "view.analysisForecastBwa.col.depreciation": "Abschreibungen",
  "view.analysisForecastBwa.col.incomeTaxes": "Ertragsteuern",
  "view.analysisForecastBwa.col.closingBalances": "Kontostand (BWA)",
  "view.analysisForecastBwa.col.differences": "Abweichung zu Uploads",
  "view.analysisForecastBwa.recordedBy": "Eingetragen von {user} am {date}",
  "view.analysisForecastBwa.changedBy": "Korrigiert von {user} am {date}",
  "view.analysisForecastBwa.action.edit": "Werte korrigieren",
  "view.analysisForecastBwa.action.delete": "Werte entfernen",
  "dialog.EditBwaMonthDialog.recordHeadline": "BWA-Monat eintragen",
  "dialog.EditBwaMonthDialog.editHeadline": "BWA-Monat korrigieren",
  "dialog.EditBwaMonthDialog.monthLabel": "Monat (JJJJ-MM)",
  "dialog.EditBwaMonthDialog.revenueLabel": "Umsatzerlöse",
  "dialog.EditBwaMonthDialog.otherOperatingIncomeLabel": "Sonstige betriebliche Erlöse",
  "dialog.EditBwaMonthDialog.personnelCostsLabel": "Personalkosten",
  "dialog.EditBwaMonthDialog.hostingAndLicencesLabel": "Hosting, Software und Lizenzen",
  "dialog.EditBwaMonthDialog.otherCostsLabel": "Sonstige Kosten",
  "dialog.EditBwaMonthDialog.otherCostsHint": "Gesamtkosten minus die übrigen Kostenfelder",
  "dialog.EditBwaMonthDialog.depreciationLabel": "Abschreibungen",
  "dialog.EditBwaMonthDialog.incomeTaxesLabel": "Steuern vom Einkommen und Ertrag",
  "dialog.EditBwaMonthDialog.closingBalanceLabel": "Kontostand {account} zum Monatsende",
  "dialog.EditBwaMonthDialog.description": "Alle Beträge netto in EUR, Kosten als positive Zahlen. Speicherst du einen Monat, der schon Werte hat, werden sie korrigiert.",
  "dialog.DeleteBwaMonthDialog.headline": "BWA-Werte entfernen",
  "dialog.DeleteBwaMonthDialog.confirmMessage": "Möchtest du die BWA-Werte von {month} wirklich entfernen? Der Monat gilt danach nicht mehr als abgeschlossen.",
  "view.analysisForecast.area.plannedItems": "Planpositionen",
  "validation.field.endMonthBeforeStartMonth": "Das Ende darf nicht vor dem Beginn liegen",
  "validation.field.invalidDayOfMonth": "Gib einen Tag von 1 bis 31 an",
  "errors.failedToAddPlannedItem": "Die Planposition konnte nicht hinzugefügt werden",
  "errors.failedToChangePlannedItem": "Die Planposition konnte nicht geändert werden",
  "errors.failedToRemovePlannedItem": "Die Planposition konnte nicht gelöscht werden",
  "errors.failedToSwitchPlannedItem": "Die Planposition konnte nicht umgeschaltet werden",
  "errors.failedToSetSubscriptionAmountOverride": "Der Betrag konnte nicht gespeichert werden",
  "errors.failedToRemoveSubscriptionAmountOverride": "Der Betrag konnte nicht entfernt werden",
  "errors.failedToSetSupplierAmountOverride": "Der Betrag konnte nicht gespeichert werden",
  "errors.failedToRemoveSupplierAmountOverride": "Der Betrag konnte nicht entfernt werden",
  "plannedItemRhythm.MONTHLY": "Monatlich",
  "plannedItemRhythm.QUARTERLY": "Quartalsweise",
  "plannedItemRhythm.YEARLY": "Jährlich",
  "plannedItemRhythm.ONE_TIME": "Einmalig",
  "plannedItemEffect.RESULT_AND_LIQUIDITY": "Ergebnis und Liquidität",
  "plannedItemEffect.LIQUIDITY_ONLY": "Nur Liquidität",
  "plannedItemEffect.RESULT_ONLY": "Nur Ergebnis",
  "view.analysisForecastPlannedItems.headline": "Planpositionen",
  "view.analysisForecastPlannedItems.addButton": "Planposition hinzufügen",
  "view.analysisForecastPlannedItems.description": "Zahlungen, die Cabana nicht aus eigenen Daten kennt, etwa Gehälter, Steuervorauszahlungen oder Versicherungen. Beträge sind netto, Abflüsse negativ. Eine ausgeschaltete Planposition bleibt erhalten, die Vorschau ignoriert sie.",
  "view.analysisForecastPlannedItems.empty": "Noch keine Planpositionen.",
  "view.analysisForecastPlannedItems.col.enabled": "An",
  "view.analysisForecastPlannedItems.col.name": "Name",
  "view.analysisForecastPlannedItems.col.rhythm": "Rhythmus",
  "view.analysisForecastPlannedItems.col.nextDueDate": "Nächste Fälligkeit",
  "view.analysisForecastPlannedItems.col.netAmount": "Betrag netto",
  "view.analysisForecastPlannedItems.dayOfMonth": "am {day}.",
  "view.analysisForecastPlannedItems.liquidityGroup": "Liquidität: {group}",
  "view.analysisForecastPlannedItems.period": "{start} bis {end}",
  "view.analysisForecastPlannedItems.from": "ab {start}",
  "view.analysisForecastPlannedItems.in": "im {start}",
  "view.analysisForecastPlannedItems.plusVat": "+ {rate} % USt",
  "view.analysisForecastPlannedItems.action.enable": "Einschalten",
  "view.analysisForecastPlannedItems.action.disable": "Ausschalten",
  "view.analysisForecastPlannedItems.action.edit": "Planposition bearbeiten",
  "view.analysisForecastPlannedItems.action.delete": "Planposition löschen",
  "view.analysisForecastPlannedItems.overrides.headline": "Eigene Beträge für Subscriptions",
  "view.analysisForecastPlannedItems.overrides.addButton": "Betrag für Subscription festlegen",
  "view.analysisForecastPlannedItems.overrides.description": "Die Einnahmen-Vorschau nimmt den Monatsbetrag aus dem letzten Settlement einer Subscription. Lege einen eigenen Betrag fest, wenn dieses Settlement zum Beispiel eine Nachberechnung enthält.",
  "view.analysisForecastPlannedItems.overrides.empty": "Noch keine eigenen Beträge.",
  "view.analysisForecastPlannedItems.overrides.col.subscription": "Subscription",
  "view.analysisForecastPlannedItems.overrides.col.monthlyNetAmount": "Betrag netto pro Monat",
  "view.analysisForecastPlannedItems.overrides.col.note": "Notiz",
  "view.analysisForecastPlannedItems.overrides.col.setBy": "Festgelegt von",
  "view.analysisForecastPlannedItems.overrides.setBy": "{user} am {date}",
  "view.analysisForecastPlannedItems.overrides.action.edit": "Betrag ändern",
  "view.analysisForecastPlannedItems.overrides.action.remove": "Betrag entfernen",
  "view.analysisForecastPlannedItems.supplierOverrides.headline": "Eigene Beträge für Lieferanten",
  "view.analysisForecastPlannedItems.supplierOverrides.addButton": "Betrag für Lieferanten festlegen",
  "view.analysisForecastPlannedItems.supplierOverrides.description": "Die Ausgaben-Vorschau setzt einen Lieferanten mit den Beträgen seiner letzten Rechnungen fort. Lege einen eigenen Betrag fest, wenn die letzte Rechnung zum Beispiel einen einmaligen Kauf enthält.",
  "view.analysisForecastPlannedItems.supplierOverrides.col.supplier": "Lieferant",
  "view.analysisForecastPlannedItems.supplierOverrides.col.netAmount": "Betrag netto pro Rechnung",
  "dialog.EditPlannedItemDialog.addHeadline": "Planposition hinzufügen",
  "dialog.EditPlannedItemDialog.editHeadline": "Planposition bearbeiten",
  "dialog.EditPlannedItemDialog.nameLabel": "Name",
  "dialog.EditPlannedItemDialog.categoryLabel": "Kategorie",
  "dialog.EditPlannedItemDialog.categoryHint": "Personal umfasst Gehälter, Lohnsteuer und Sozialabgaben. Finanzierung (etwa ein Darlehen) ändert nur die Liquidität. In Monaten mit BWA kommen Personal, Abschreibungen, Steuern vom Einkommen und Ertrag und sonstige betriebliche Erlöse aus der BWA, Planpositionen dieser Kategorien zählen dort nur für die Liquidität.",
  "dialog.EditPlannedItemDialog.netAmountLabel": "Betrag netto",
  "dialog.EditPlannedItemDialog.netAmountHint": "Negativ für Abflüsse, z. B. -700,00",
  "dialog.EditPlannedItemDialog.vatRateLabel": "Umsatzsteuersatz",
  "dialog.EditPlannedItemDialog.rhythmLabel": "Rhythmus",
  "dialog.EditPlannedItemDialog.startMonthLabel": "Erster Monat (JJJJ-MM)",
  "dialog.EditPlannedItemDialog.endMonthLabel": "Letzter Monat (JJJJ-MM), optional",
  "dialog.EditPlannedItemDialog.dayOfMonthLabel": "Fälligkeitstag im Monat",
  "dialog.EditPlannedItemDialog.dayOfMonthHint": "In einem kürzeren Monat gilt der letzte Tag.",
  "dialog.EditPlannedItemDialog.effectLabel": "Wirkung",
  "dialog.EditPlannedItemDialog.liquidityGroupLabel": "Zahlung an (Liquidität)",
  "dialog.EditPlannedItemDialog.liquidityGroupSameAsCategory": "Wie die Kategorie",
  "dialog.EditPlannedItemDialog.liquidityGroupHint": "Die Zeile der Liquidität, in der die Zahlung steht. Die Lohnsteuer zum Beispiel ist im Ergebnis Personalaufwand, wird aber ans Finanzamt gezahlt.",
  "dialog.DeletePlannedItemDialog.headline": "Planposition löschen",
  "dialog.DeletePlannedItemDialog.confirmMessage": "Möchtest du die Planposition „{name}“ wirklich löschen? Willst du sie behalten, schalte sie stattdessen aus.",
  "dialog.EditSubscriptionAmountOverrideDialog.addHeadline": "Betrag für Subscription festlegen",
  "dialog.EditSubscriptionAmountOverrideDialog.editHeadline": "Betrag einer Subscription ändern",
  "dialog.EditSubscriptionAmountOverrideDialog.subscriptionLabel": "Subscription",
  "dialog.EditSubscriptionAmountOverrideDialog.monthlyNetAmountLabel": "Betrag netto pro Monat",
  "dialog.EditSubscriptionAmountOverrideDialog.noteLabel": "Notiz",
  "dialog.EditSubscriptionAmountOverrideDialog.description": "Suche nach dem Kunden oder dem Label der Subscription. Die Einnahmen-Vorschau nimmt diesen Betrag pro Monat statt des Betrags aus den Settlements.",
  "dialog.RemoveSubscriptionAmountOverrideDialog.headline": "Betrag entfernen",
  "dialog.RemoveSubscriptionAmountOverrideDialog.confirmMessage": "Möchtest du den eigenen Betrag für {subscription} wirklich entfernen? Die Einnahmen-Vorschau nimmt dann wieder den Betrag aus den Settlements.",
  "dialog.EditSupplierAmountOverrideDialog.addHeadline": "Betrag für Lieferanten festlegen",
  "dialog.EditSupplierAmountOverrideDialog.editHeadline": "Betrag eines Lieferanten ändern",
  "dialog.EditSupplierAmountOverrideDialog.supplierLabel": "Lieferant",
  "dialog.EditSupplierAmountOverrideDialog.netAmountLabel": "Betrag netto pro Rechnung",
  "dialog.EditSupplierAmountOverrideDialog.noteLabel": "Notiz",
  "dialog.EditSupplierAmountOverrideDialog.description": "Zur Auswahl stehen Lieferanten, die regelmäßig abrechnen. Die Ausgaben-Vorschau setzt den Lieferanten dann mit einer Rechnung pro Abrechnungszeitraum über diesen Betrag fort, statt mit den Beträgen seiner letzten Rechnungen. 0 nimmt ihn aus der Vorschau.",
  "dialog.RemoveSupplierAmountOverrideDialog.headline": "Betrag entfernen",
  "dialog.RemoveSupplierAmountOverrideDialog.confirmMessage": "Möchtest du den eigenen Betrag für {supplier} wirklich entfernen? Die Ausgaben-Vorschau setzt dann wieder seine letzten Rechnungen fort.",
  "view.analysisForecast.area.overview": "Übersicht",
  "view.analysisForecastOverview.loading": "Die Vorschau wird berechnet …",
  "view.analysisForecastOverview.currentBalance": "Kontostand (beide Konten)",
  "view.analysisForecastOverview.asOf": "Stand: {date}, danach Vorschau",
  "view.analysisForecastOverview.minimumBalance": "Mindestbestand",
  "view.analysisForecastOverview.minimumBalance.notSet": "nicht festgelegt",
  "view.analysisForecastOverview.minimumBalance.edit": "Mindestbestand ändern",
  "view.analysisForecastOverview.minimumBalance.save": "Speichern",
  "view.analysisForecastOverview.minimumBalance.cancel": "Abbrechen",
  "view.analysisForecastOverview.minimumBalance.description": "Für beide Konten zusammen",
  "view.analysisForecastOverview.shortfall": "Am {date} fällt der Kontostand unter den Mindestbestand.",
  "view.analysisForecastOverview.noShortfall": "In der Vorschau fällt der Kontostand nicht unter den Mindestbestand.",
  "view.analysisForecastOverview.chart.headline": "Kontostand zum Monatsende",
  "view.analysisForecastOverview.chart.total": "Beide Konten",
  "view.analysisForecastOverview.chart.legend": "Durchgezogen: Kontostand laut Bank. Gestrichelt: Vorschau. Die Linien der einzelnen Konten gibt es nur für Monate, die die Kontoauszüge vollständig abdecken.",
  "view.analysisForecastOverview.status.CLOSED": "mit BWA",
  "view.analysisForecastOverview.status.PROVISIONAL": "ohne BWA",
  "view.analysisForecastOverview.status.BANK": "Bank",
  "view.analysisForecastOverview.status.BANK_AND_FORECAST": "Bank + Vorschau",
  "view.analysisForecastOverview.status.FORECAST": "Vorschau",
  "view.analysisForecastOverview.status.CLOSED.title": "Für diesen Monat sind BWA-Werte eingetragen: Personal, Abschreibungen und Steuern stammen aus der BWA.",
  "view.analysisForecastOverview.status.PROVISIONAL.title": "Vergangener Monat, für den noch keine BWA-Werte eingetragen sind: Personal, Abschreibungen und Steuern fehlen oder sind geschätzt.",
  "view.analysisForecastOverview.status.FORECAST.title": "Aktueller oder künftiger Monat: bestehende Rechnungen plus erwartete Beträge und Planpositionen.",
  "view.analysisForecastOverview.result.statusLegend": "mit BWA: Werte aus der BWA sind eingetragen. ohne BWA: vergangener Monat, für den die BWA noch fehlt (kursiv). Vorschau: aktueller oder künftiger Monat (kursiv).",
  "view.analysisForecastOverview.result.headline": "Ergebnis",
  "view.analysisForecastOverview.result.description": "Netto, nach Leistungsmonat. Umsatz und Lieferanten kommen immer aus Cabana. In Monaten mit BWA stammen Personal, Abschreibungen, Steuern vom Einkommen und Ertrag und sonstige betriebliche Erlöse aus der BWA.",
  "view.analysisForecastOverview.result.beforeIncomeTaxes": "Ergebnis vor Steuern",
  "view.analysisForecastOverview.result.result": "Ergebnis",
  "view.analysisForecastOverview.result.bwa.REVENUE": "Umsatz laut BWA",
  "view.analysisForecastOverview.result.bwa.SUPPLIERS": "Lieferanten laut BWA",
  "view.analysisForecastOverview.result.bwa.description": "Die Zeilen „laut BWA“ zeigen Umsatz und Kosten (Hosting, Lizenzen und sonstige Kosten) so, wie der Steuerberater sie bucht: nach Rechnungsdatum. Sie gehören deshalb meist zum Vormonat, dienen nur zum Vergleich und zählen nicht zum Ergebnis.",
  "view.analysisForecastOverview.liquidity.headline": "Liquidität",
  "view.analysisForecastOverview.liquidity.description": "Brutto, nach Zahlungstag. Bis zum letzten Buchungstag zählen die Buchungen der Bank, danach die Vorschau. Überfällige Forderungen erwartet die Vorschau nach der üblichen Zahlungsdauer des Kunden, frühestens sieben Tage nach dem letzten Buchungstag.",
  "view.analysisForecastOverview.liquidity.opening": "Anfangsbestand",
  "view.analysisForecastOverview.liquidity.totalInflows": "Zuflüsse gesamt",
  "view.analysisForecastOverview.liquidity.totalOutflows": "Abflüsse gesamt",
  "view.analysisForecastOverview.liquidity.overdueReceivables": "überfällige Forderungen",
  "view.analysisForecastOverview.liquidity.transfers": "Umbuchungen (netto)",
  "view.analysisForecastOverview.liquidity.closing": "Endbestand",
  "view.analysisForecastOverview.liquidity.lowest": "Niedrigster Stand",
  "view.analysisForecastOverview.legend.liquidityForecast": "Monate mit Vorschau, ganz oder teilweise",
  "view.analysisForecastOverview.legend.drillDown": "Ein Klick auf einen Betrag zeigt, woraus er besteht.",
  "view.analysisForecastOverview.parts.headline": "{table}: {line}, {month}",
  "view.analysisForecastOverview.parts.result": "Ergebnis",
  "view.analysisForecastOverview.parts.liquidity": "Liquidität",
  "view.analysisForecastOverview.parts.bwa": "BWA",
  "view.analysisForecastOverview.parts.close": "Schließen",
  "view.analysisForecastOverview.parts.expectedPayment": "Erwartete Zahlung",
  "view.analysisForecastOverview.parts.paymentDay": "Zahltag",
  "view.analysisForecastOverview.parts.net": "Netto",
  "view.analysisForecastOverview.parts.vat": "USt",
  "view.analysisForecastOverview.parts.gross": "Brutto",
  "view.analysisForecastOverview.parts.sum": "Summe",
  "view.analysisForecastOverview.parts.invoicesLabel": "{count, plural, one {# Rechnung} other {# Rechnungen}}",
  "view.analysisForecastOverview.parts.postponed": "verschoben in den Folgemonat",
  "view.analysisForecastOverview.parts.expected": "erwartet",
  "view.analysisForecastOverview.parts.estimate.INVOICED_USAGE": "Verbrauch laut {source}-Rechnung",
  "view.analysisForecastOverview.parts.estimate.ESTIMATE": "Schätzung {source}, Stand {date}",
  "view.analysisForecastOverview.parts.estimate.CONTINUED_ESTIMATE": "Schätzung {source} fortgeschrieben, Stand {date}",
  "view.analysisForecastOverview.parts.estimateSource.HETZNER": "Hetzner",
  "view.analysisForecastOverview.parts.bankBookingsLabel": "Buchungen der Bank bis {date}",
  "view.analysisForecastOverview.parts.kind.BWA": "BWA",
  "view.analysisForecastOverview.parts.kind.INVOICES": "Ausgangsrechnungen nach Kunde",
  "view.analysisForecastOverview.parts.kind.EXPENSE_SUPPLIER": "Eingangsrechnungen nach Kostenart und Lieferant",
  "view.analysisForecastOverview.parts.kind.BANK_BOOKINGS": "Bank",
  "view.analysisForecastOverview.parts.kind.SUBSCRIPTION": "Subscriptions",
  "view.analysisForecastOverview.parts.kind.OPEN_INVOICE": "Offene Rechnungen",
  "view.analysisForecastOverview.parts.kind.SUPPLIER": "Lieferanten",
  "view.analysisForecastOverview.parts.kind.PLANNED_ITEM": "Planpositionen",
  "view.analysisForecastOverview.parts.kind.VAT_PAYMENT": "Umsatzsteuerzahlung",
  "view.analysisForecastOverview.accountsDiffer": "Die Kontoauszüge decken unterschiedlich weit ab: {accounts}. Die Vorschau beginnt nach dem {date}.",
  "view.analysisForecastOverview.accountsDiffer.account": "{name} bis {date}",
  "view.analysisForecastOverview.parts.vatPaymentLabel": "Umsatzsteuer {month}",
  "view.analysisForecastOverview.parts.vat.header": "Umsatzsteuer für {month}, fällig am {date}",
  "view.analysisForecastOverview.parts.vat.OUTGOING_INVOICES": "Umsatzsteuer aus {count, plural, one {# Ausgangsrechnung} other {# Ausgangsrechnungen}}",
  "view.analysisForecastOverview.parts.vat.INCOMING_INVOICES": "Vorsteuer aus {count, plural, one {# Eingangsrechnung} other {# Eingangsrechnungen}}",
  "view.analysisForecastOverview.doubtful.headline": "Zweifelhafte Forderungen",
  "view.analysisForecastOverview.doubtful.description": "Offene, überfällige Rechnungen, mit deren Zahlung die Vorschau nicht mehr rechnet. Sie sind nicht Teil der Vorschau.",
  "view.analysisForecastOverview.doubtful.customer": "Kunde",
  "view.analysisForecastOverview.doubtful.invoice": "Rechnung",
  "view.analysisForecastOverview.doubtful.reason": "Grund",
  "view.analysisForecastOverview.doubtful.reason.LONG_OVERDUE": "über 90 Tage überfällig",
  "view.analysisForecastOverview.doubtful.reason.SLOW_PAYER": "langsamer Zahler",
  "view.analysisForecastOverview.doubtful.overdue": "Überfällig",
  "view.analysisForecastOverview.doubtful.amount": "Brutto",
  "view.analysisForecastOverview.doubtful.days": "{count, plural, one {# Tag} other {# Tage}}",
  "view.analysisForecastOverview.hint": "Vorschau-Monate beruhen auf laufenden Subscriptions, wiederkehrenden Lieferanten und Planpositionen. Planpositionen lassen sich unter <link>Planpositionen</link> an- und ausschalten.",
  "view.analysisForecastOverview.noBankAccount": "Ohne Bankkonto kennt die Vorschau keinen Kontostand. Lege eines unter <link>Konfiguration → Finanzen</link> an.",
  "errors.failedToSetMinimumBalance": "Der Mindestbestand konnte nicht gespeichert werden."
}
